$.jqCellDeatails = function (data) {
    $('#cellDetails').remove();
    var buttons = [];
    buttons[buttons.length] = {
        text: "Закрыть",
        class: "fm-button f-left",
        style: "color: #bdbdbd;",
        click: function () {
            $(this).dialog("close");
        }
    };
    var dialog = $('<div id="cellDetails_wrap"></div>')
        .html('<div id="cellDetails"></div>')
        .dialog({
            autoOpen: false,
            title: data.title,
            modal: true,
            resizable: true,
            zIndex: 10,
            width: '55%',
            height: 'auto',
            position: {
                my: 'center',
                at: 'top',
                of: window
            },
            create: function(event, ui) {
                $.nameSpcTmp('cellDetails');
                $(this).dialog('open');
                simpleGetDataGrid(data.url, '#cellDetails');
            },
            open: function(event, ui) {
                // $('#evml_comment').focusout().blur();
            },
            close: function(event, ui) {
                $.nameSpcReturn('cellDetails');
                $(this).dialog('destroy');
                $('#cellDetails_wrap').remove();
            },
            buttons: buttons
        });
    dialog.dialog('open');
};

$.subdivisionCompositionRefresh = function(jqGId){
    $('#106, #107, #108, #109, #110, #189').find('.ui-inline-save').parent().append('<div class="ui-pg-div ui-inline-refresh" title="Обновить состав"><span class="ui-icon ui-icon-refresh"></span></div>');
    $('#106, #107, #108, #109, #110, #189').find('.ui-icon-refresh').click(function () {
        var sd_id = $(this).parents('tr:first').attr('id'),
            sd_name = $('#' + sd_id + ' td[aria-describedby="grid_sd_name"]').text();
        $.create_popup_dialog('Обновить состав для подразделения "'+sd_name+'" ?', 'Подтверждение', function(){
            showAjaxLoading();

            $.ajax({
                type: "POST",
                url: `php/cron/subdivision_composition_refresh${sd_id === '189' ? '_deputies_gdfr' : ''}.php`,
                dataType: 'json',
                data: { sd_id },
                success: function (tr){
                    hideAjaxLoading();
                    checkSession(tr);
                    var $dialog = $('<div id="subdivisionCompositionRefreshed"></div>')
                        .html('Состав успешно обновлен')
                        .dialog({
                            autoOpen: false,
                            title: 'Обновление состава',
                            modal: true,
                            resizable: false,
                            zIndex : 3001,
                            close: function(ev, ui) {
                                $(this).dialog('destroy');
                                $('#subdivisionCompositionRefreshed').remove();
                            },
                            buttons: [{
                                text: 'Ок',
                                click: function() {
                                    $(this).dialog('close');
                                }
                            }]
                        });
                    $dialog.dialog('open');
                    $('.ui-dialog-buttonset :button').blur();
                }
            });
        });
    });
};

$.jqRestoreMemb = function (m_id) {
    $.create_popup_dialog('Восстановить персоналия ?', 'Подтверждение', function () {
        showAjaxLoading();
        $.post('php/getData.php', {qryType: 'restoreMemb', m_id: m_id}, function (tr) {
            hideAjaxLoading();
            if(checkSession(tr)){
                if(tr.error){
                    var dialog = $('<div id="category_change_alert"></div>')
                        .html(tr.error)
                        .dialog({
                            autoOpen: true,
                            title: "ВНИМАНИЕ",
                            modal: true,
                            resizable: true,
                            zIndex : 3001,
                            width: 'auto',
                            height: 80,
                            position: { my: "center", mx: "center", of: window },
                            close: function(ev, ui) {
                                $(this).dialog("destroy");
                                $(this).remove();
                            },
                            buttons: []
                        });
                    dialog.dialog('open');
                    $('body .ui-widget-overlay:last').click(function(){
                        dialog.dialog('close');
                    });
                } else {
                    $('#grid').trigger('reloadGrid');
                }
            }
        }, 'json');
    });
};

$.addRikEmailNotify = function (rowid) {
    var nfData = {};
    if (rowid) {
        nfData = $('#grid').jqGrid('getRowData', rowid);
        nfData.nf_text_email = $('#' +rowid + ' td[aria-describedby="grid_nf_text_email"] span').attr('originalvalue');
        nfData.nf_priority = $('#' +rowid + ' td[aria-describedby="grid_nf_priority"]').attr('originalvalue');
    }

    var dialog = $('<div></div>')
        .html('<div id="add_sms_notify">' + $('#add_rik_email_notify_tmpl').html().replace(/\{TMPL\}/g, '') + '</div>')
        .dialog({
            autoOpen: false,
            title: (rowid ? 'Редактирование' : 'Создание') + ' рассылки',
            modal: true,
            resizable: false,
            zIndex : 3001,
            width: 'auto',
            position: {
                my: 'center',
                at: 'top',
                of: window
            },
            open: function (ev, ui) {
                if (rowid) {
                    $('#add_sms_notify').parents('.ui-dialog').css('opacity', 0);
                }
                $('#add_sms_notify .sn_email_subj').blur();
                $('#add_sms_notify .choose_ro').on('click', function () {
                    showAjaxLoading();
                    $.get(
                        'php/getData.php', {
                            qryType: 'getRikList'
                        }, function (tr) {
                            hideAjaxLoading();
                            checkSession(tr);

                            var rik_cnt = tr.data.length,
                                second_col_index = 0,
                                xhtml = '';

                            xhtml +=
                                '<div class="padd-bot-10">' +
                                    '<a href="javascript:void(0)" class="check_all_ro button">Выбрать все</a> | ' +
                                    '<a href="javascript:void(0)" class="uncheck_all_ro button">Сбросить все</a>' +
                                '</div>';

                            /* Добавляем чекбоксы для возможности выбора целого ФО */
                            xhtml += '<div class="rikList__popup__districtsList">';
                            tr.districtsList.forEach((districtData) => {
                                xhtml += `
                                    <label>
                                        <input class="district_notify" d_id="${districtData.d_id}" type="checkbox">
                                        <span>${districtData.d_name}</span>
                                    </label>
                                `;
                            })
                            xhtml += '</div><hr>';

                            xhtml += '<table>';
                            for (var i = 0; i < Math.ceil(rik_cnt / 2); i ++) {
                                second_col_index = i + Math.ceil(rik_cnt / 2);
                                xhtml += '<tr>';
                                for (var j = 0; j < 2; j++) {
                                    var rik_index = (j === 0 ? i : second_col_index);
                                    xhtml +=
                                        '<td class="padd-right-15">' +
                                            (tr.data[rik_index] ?
                                                `<label>
                                                    <input
                                                        class="rik_notify checkBoxShift"
                                                        r_id="${tr.data[rik_index].r_id}"
                                                        r_district_id="${tr.data[rik_index].r_district_id}"
                                                        type="checkbox"
                                                    >
                                                    <span class="notify_r_name">${tr.data[rik_index].r_name}</span>
                                                </label>` : '') +
                                        '</td>';
                                }
                                xhtml += '</tr>';
                            }
                            xhtml += '</table>';

                            let checkedRo = [];
                            $.create_popup_dialog(
                                xhtml,
                                'Выбор РО',
                                function () {
                                    $('#add_sms_notify .email_notify_r_list').html('');
                                    var checked_cnt = 0,
                                        cols = ['td:first-child', 'td:nth-child(2)'];
                                    cols.forEach(function(col) {
                                        $.each($('#popup_dialog_form tr ' + col + ' .rik_notify:checked'), function (k, v) {
                                            $('#add_sms_notify .email_notify_r_list').append(
                                                (checked_cnt ? ', ' : '') +
                                                '<span class="checked_ro" r_id="' + $(this).attr('r_id') + '">' +
                                                    $(this).parent().find('.notify_r_name').html() +
                                                '</span>'
                                            );
                                            checked_cnt++;
                                        });
                                    });
                                    $('#add_sms_notify .sn_resivers_wrap .sn_resivers').html(checked_cnt);
                                },
                                false,
                                function (popup_id) {
                                    /* Проставляем чекбоксы у регионов, которые уже были выбраны на предыдущих шагах */
                                    $.each($('#add_sms_notify .checked_ro'), function () {
                                        const rId = $(this).attr('r_id');
                                        $(`#${popup_id} .rik_notify[r_id="${rId}"]`).prop('checked', true);
                                        checkedRo.push(rId);
                                    });

                                    $(`#${popup_id} .district_notify`).each(function() {
                                        const districtCheckbox = $(this);
                                        const dId = districtCheckbox.attr('d_id');

                                        let isDistrictWhole = true;
                                        $(`#${popup_id} .rik_notify[r_district_id="${dId}"]`).each(function() {
                                            const rId = $(this).attr('r_id');
                                            if (!checkedRo.includes(rId)) {
                                                isDistrictWhole = false;
                                                return false;
                                            }
                                        })

                                        if (isDistrictWhole) {
                                            districtCheckbox.prop('checked', true);
                                        }
                                    });

                                    /* Добавляем обработчик событий для чекбоксов.
                                    * Попап содержит чекбоксы выбора РО и ФО.
                                    * Обработчик события "change" навешиваем на корневой элемент попапа (используем всплытие).
                                    * При возникновении события, идентифицируем чекбокс (РО или ФО) по css классу.
                                    * Далее обработка события выполняется в зависимости от чекбокса (РО или ФО).
                                    *  */
                                    $(`#${popup_id}`).change(function(event) {
                                        const eventTarget = $(event.target);
                                        function changeCheckedRo(rId) {
                                            if (eventTarget.prop('checked') && !checkedRo.includes(rId)) {
                                                checkedRo.push(rId);
                                            }
                                            else if (!eventTarget.prop('checked') && checkedRo.includes(rId)) {
                                                checkedRo.splice(checkedRo.indexOf(rId), 1);
                                            }
                                        }
                                        if (eventTarget.hasClass('district_notify')) {
                                            /* При выборе ФО для регионов, входящих в ФО, устанавливаем значение чекбокса как у ФО */
                                            const dId = eventTarget.attr('d_id');
                                            $(`#popup_dialog_form .rik_notify[r_district_id="${dId}"]`).each(function() {
                                                const regionCheckbox = $(this);
                                                regionCheckbox.prop('checked', eventTarget.prop('checked'));

                                                changeCheckedRo(regionCheckbox.attr('r_id'));
                                            })
                                        }

                                        if (eventTarget.hasClass('rik_notify')) {
                                            /* Если выбраны все регионы, входящие в ФО, то активируем чекбокс ФО.
                                            * Если выбраны не все - деактивируем.
                                            *  */
                                            changeCheckedRo(eventTarget.attr('r_id'));

                                            const dId = eventTarget.attr('r_district_id');
                                            const districtCheckbox = $(`.district_notify[d_id="${dId}"]`);

                                            let isDistrictWhole = true;
                                            $(`#popup_dialog_form .rik_notify[r_district_id="${dId}"]`).each(function() {
                                                const rId = $(this).attr('r_id');
                                                if (!checkedRo.includes(rId)) {
                                                    isDistrictWhole = false;
                                                    return false;
                                                }
                                            })

                                            if (isDistrictWhole) {
                                                districtCheckbox.prop('checked', true);
                                            }
                                            else {
                                                districtCheckbox.prop('checked', false);
                                            }
                                        }
                                    })
                                },
                                () => checkedRo = []
                            );

                            $('.check_all_ro').on('click', function () {
                                $('#popup_dialog .rik_notify').prop('checked', true);
                                $('#popup_dialog .district_notify').prop('checked', true);
                            });
                            $('.uncheck_all_ro').on('click', function () {
                                $('#popup_dialog .rik_notify').prop('checked', false);
                                $('#popup_dialog .district_notify').prop('checked', false);
                            });
                        },
                        'json'
                    );
                });
            },
            create: function( event, ui ) {
                $('#add_sms_notify .sn_datetime')
                    .datetimepicker({
                        dateFormat: 'dd.mm.yy',
                        timeFormat: 'hh:mm'
                    })
                    .blur();

                $('#add_sms_notify .button').button();
                $.inputHints('#add_sms_notify .sn_email_subj', 'Тема email:');

                $.getScript('js/jquery.tinymce.js', function(){
                    const tinyMceSettings = Object.assign(getTinyMceDefaultSettings('multiple'), {
                        oninit: function () {
                            if (rowid) {
                                $('#add_sms_notify .sn_text_email').tinymce().execCommand('mceInsertContent', false, nfData.nf_text_email);
                            }
                        }
                    });
                    $('#add_sms_notify .sn_text_email').tinymce(tinyMceSettings);
                });
                if (rowid) {
                    $('#add_sms_notify').find('.sn_email_subj').val(nfData.nf_email_subj).removeClass('grey');
                    var datetime = nfData.nf_datetime.split(' '),
                        date = datetime[0].split('.'),
                        time = datetime[1].split(':');
                    $('#add_sms_notify .sn_datetime').removeClass('grey').datetimepicker('setDate', (new Date(date[2], date[1]-1, date[0], time[0], time[1])) );
                    $('#add_sms_notify .sn_resivers').html(nfData.nf_receivers);
                    $('#add_sms_notify .nf_priority').val(nfData.nf_priority);
                    showAjaxLoading();
                    $.get(
                        'php/getData.php', {
                            qryType: 'getRikEmailNotifyReceivers',
                            nf_id: rowid
                        }, function (tr) {
                            hideAjaxLoading();
                            checkSession(tr);
                            $('#add_sms_notify').parents('.ui-dialog').css('opacity', 1);
                            if (tr.data[0].read_only === 't') {
                                $('#add_sms_notify').html('<span class="color-red">Нельзя редактировать - до рассылки меньше часа</span>');
                            } else {
                                $.each(tr.data, function (k, v) {
                                    $('#add_sms_notify .email_notify_r_list').append(
                                        (k ? ', ' : '') +
                                        '<span class="checked_ro" r_id="' + this.r_id + '">' +
                                        this.r_name +
                                        '</span>'
                                    );
                                });
                            }
                        },
                        'json'
                    );
                }
            },
            close: function () {
                $('#add_sms_notify .sn_text_email').tinymce().remove();
                $(this).dialog('destroy');
                $(this).remove();
            },
            buttons: [{
                    text: rowid ? 'Сохранить' : 'Создать',
                    class: 'submit fm-button f-right',
                    click: function(){
                        $('#add_sms_notify .ui-dialog-buttonpane .error-msg').slideUp(function(){
                            $(this).remove();
                        });
                    }
                }, {
                    text: 'Отмена',
                    class: 'fm-button f-left',
                    style: 'color: #bdbdbd;',
                    click: function() {
                        $(this).dialog('close');
                    }
                }]
        });
    dialog.dialog('open');
    $('#add_sms_notify').parent().next().appendTo('#add_sms_notify');
    $('#tmplDirName').val(__userId__ + '_' +new Date().getTime());

    $("#add_sms_notify .add_file").on('click', function(e){
        $('input#filesToUpload').click();
    });

    $('input#filesToUpload').change(function() {
        var formData = new FormData(),
            currentFiles =[];
        $('#ulListFiles li').map(function(){ currentFiles.push($(this).text());});

        for (var i = 0, file; file = this.files[i]; ++i) {
            if(currentFiles.indexOf(file.name) != -1){
                $('ul#ulListFiles li:contains(\"'+file.name+'\")').remove();
            }
            $('ul#ulListFiles').append($( '<li class="attachment newFile"  title="Новый файл"><i class="fa fa-file color-orange"></i>'+file.name+'</li>'));
            formData.append('file-'+i, file);
        }
        formData.append('qryType','multiupload');
        formData.append('tmplDirName',$('#tmplDirName').val());

        $.ajax({
            type:'POST',
            url:'/php/getData.php',
            cache: false,
            processData: false,
            contentType: false,
            data: formData,
            success: function(tr){
                if( checkSession(tr) ){
                    $('#ulListFiles i.fa-file').removeClass('color-orange').addClass('color-green');
                    $('#ulListFiles li.newFile').append('<i class="color-red fa fa-times"></i>').removeClass('newFile');

                    $('#ulListFiles i.fa-times').click(function(){
                        $(this).parent().remove();
                    });

                }
            }
        });
    });

    if (rowid) {
        var filesInGrid = $.each($('#'+rowid+' td[aria-describedby="grid_nf_email_attach"] a'),function(){return this;});
        if (filesInGrid.length){
            for (var i = 0, len = filesInGrid.length; i<len; i++){
                $('#ulListFiles').append($( '<li class="attachment inAttach" title="Загрузить файл"><i class = "fa fa-file color-blue"></i><a target="_blank" href=\"'+filesInGrid[i].href+'\">'+filesInGrid[i].text+'</a><i class="color-red fa fa-times"></i></li>'));
            }
            $('li.inAttach .fa-times').click(function(){
                var fName = $(this).prev().text();
                $(this).parent().remove();
                $.ajax({
                    type: 'POST',
                    url: 'php/getData.php',
                    dataType: 'json',
                    data: {
                        qryType: 'removeAttachFile',
                        fileName: fName,
                        nfId: rowid
                    },
                    success: function(tr){
                        checkSession(tr);
                    }
                });
            });
        }
    }

    $.wrapSubmit('#add_sms_notify');

    $('#add_sms_notify form').validate({
        keyup: true,
        ignoreTitle: true,
        focusInvalid: false,
        focusCleanup: true,
        showErrors: function(errorMap, errorList) {
            for (var i = 0; i < errorList.length; i++){
                if ($(errorList[i].element).hasClass('sn_text_email')){
                    if ($.trim($('#add_sms_notify .sn_text_email').tinymce().getContent()) == '') {
                        errorList[i].element = $('.mceLayout');
                        $('.mceLayout').css({border: '1px solid red'});
                    } else {
                        errorList.splice(i, 1);
                        $('.mceLayout').removeAttr('style');
                    }
                }
            }
            this.defaultShowErrors();
        },
        submitHandler:function (form) {
            var receivers = parseInt($('#add_sms_notify .sn_resivers_wrap .sn_resivers').html());
            if (receivers === 0) {
                $('#add_sms_notify .result').html('<hr><span class="color-red">Выберите РО</span>');
            } else {
                var confirmDialog = $('<div></div>')
                    .html(
                        '<span style="font-size: 20px;"><b>Количество получателей:</b> ' + receivers + '</span>' +
                        '<br><b>Тема email:</b> ' + $('#add_sms_notify .sn_email_subj').val() +
                        '<br><br>' +
                        'Точно ' + (rowid ? 'редактировать' : 'добавить') + ' рассылку ?'
                    )
                    .dialog({
                        autoOpen: false,
                        title: 'Подтверждение',
                        modal: true,
                        resizable: false,
                        width: 'auto',
                        zIndex : 3001,
                        close: function(ev, ui) {
                            $(this).dialog('destroy');
                            $(this).remove();
                        },
                        buttons: [{
                            text: 'Ок',
                            class: 'submit fm-button f-right',
                            click: function() {
                                var data = $('#add_sms_notify form').serializeArray();
                                data.push({name: 'qryType', value: 'addRikEmailNotify'});
                                data.push({name: 'sn_text_email', value: $('#add_sms_notify .sn_text_email').tinymce().getContent()});
                                var r_ids = [];
                                $.each($('#add_sms_notify .checked_ro'), function () {
                                    r_ids.push($(this).attr('r_id'));
                                });
                                r_ids = r_ids.join(',');
                                data.push({name: 'r_ids', value: r_ids});
                                if (rowid) {
                                    data.push({name: 'nf_id', value: rowid});
                                }
                                data.push({name: 'sn_email_attach', value: $("#tmplDirName").val()});
                                var filesList = [];
                                $('#ulListFiles li').each(function(){
                                    filesList.push($(this).text());
                                });
                                data.push({name: 'files', value: JSON.stringify(filesList)});
                                $(this).dialog('close');

                                showAjaxLoading();
                                $.ajax({
                                    type: 'POST',
                                    url: 'php/getData.php',
                                    dataType: 'json',
                                    data: data,
                                    success: function (tr) {
                                        hideAjaxLoading();
                                        checkSession(tr);
                                        if (tr.error != '') {
                                            $('#add_sms_notify .result').html('<hr><span class="color-red">' + tr.error + '</span>');
                                        } else {
                                            dialog.dialog('close');
                                            if (rowid) {
                                                $('#grid').trigger('reloadGrid');
                                            }
                                            var succDialog = $('<div id="notify_popup"></div>')
                                                .html('Рассылка успешно ' + (rowid ? 'отредактирована' : 'создана'))
                                                .dialog({
                                                    autoOpen: false,
                                                    title: 'Создание рассылки',
                                                    modal: true,
                                                    resizable: false,
                                                    zIndex : 3001,
                                                    close: function (ev, ui) {
                                                        $(this).dialog('destroy');
                                                        $(this).remove();
                                                    },
                                                    buttons: [{
                                                        text: 'Ок',
                                                        click: function() {
                                                            $(this).dialog('close');
                                                        }
                                                    }]
                                                });
                                            succDialog.dialog('open');
                                            $('.ui-dialog-buttonset :button').blur();
                                            setTimeout(function(){
                                                if ($('#notify_popup').length) {
                                                    succDialog.dialog('close');
                                                }
                                            }, 3000);
                                        }
                                    }
                                });
                            }
                        }, {
                            text: 'Отмена',
                            class: 'fm-button f-left',
                            style: 'color: #bdbdbd;',
                            click: function() {
                                $(this).dialog('close');
                            }
                        }]
                    });

                confirmDialog.dialog('open');
                $('.ui-dialog-buttonset :button').blur();
            }
        }
    });
};

$.jqGridDateTimeValidator = function (value, colname) {
    var re = /^([0-9]{2}).([0-9]{2}).([0-9]{4})\s([0-9]{2}):([0-9]{2})$/;
    if (re.test(value)) {
        return [true];
    } else {
        return [false, colname + ': Пожалуйста, введите правильную дату - d.m.Y H:i'];
    }
};

$.jqGridDateTimeWithSecondsValidator = function (value, colname) {
    var re = /^([0-9]{2}).([0-9]{2}).([0-9]{4})\s([0-9]{2}):([0-9]{2}):([0-9]{2})$/;
    if (re.test(value)) {
        return [true];
    } else {
        return [false, colname + ': Пожалуйста, введите правильную дату - d.m.Y H:i:s'];
    }
};

$.jqGridAddRequiredMark = function (grid_id) {
    var colModel = $('#' + grid_id).jqGrid('getGridParam', 'colModel'),
        tr;
    for (var i in colModel) {
        tr = $('#tr_' + colModel[i].name + ' .CaptionTD');
        if (colModel[i].editrules && colModel[i].editrules.required) {
            tr.addClass('FillThisField');
        } else {
            tr.removeClass('FillThisField');
        }
    }
};

var url_valid = function(url){
    return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
};

var calcSmsCnt = function(sms_text_length){
    return sms_text_length > 70 ? Math.ceil(sms_text_length / 67) : 1;
};

/**
 * @description генерирует эксель из html-элементов, переданных в качестве селекторов
 * @type {(function(*=, *): void)|*}
 */
var tableToExcel = (() => {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table style="font-family: Times New Roman;">{table}</table></body></html>';
    const base64 = s => window.btoa(unescape(encodeURIComponent(s)));
    const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p] );

    return (selector = '#excel_data', excel_fn = 'exportdata') => {
        const elements = document.querySelectorAll(selector);
        let elementsHtml = '';
        elements.forEach(elm => elementsHtml += elm.innerHTML);
        const ctx = {worksheet: "Worksheet", table: elementsHtml};

        const anchor = document.createElement('a');
        anchor.href = uri + base64(format(template, ctx));
        anchor.download = `${excel_fn}.xls`;
        anchor.click();
    }
})();

$.jqGridCpgiExcelReport = function(report_type){
    showAjaxLoading();
    $.ajax({
        type: 'GET',
        url: dirUp + 'php/tbl.CPGI.EXCEL.REPORT.php',
        dataType: 'html',
        data: {
            report_type: report_type,
            sql: $('#cpgi_last_query').val()
        },
        success: function(tr){
            hideAjaxLoading();
            checkSession(tr);
            $('#work_panel_wrap').append('<div id="excel_data" class="hidden">'+tr+'</div>');

            tableToExcel('#export_data_table');
            $('#excel_data').remove();
        }
    });
};

$.dlgChangeVKS = function(){
    if(__userRole__ !== 'sys-admin'){
        return false;
    }

    $("#work_panel span.empl_change_vks").click(function(){
        var emplID = $(this).parents('tr:first').find('td[aria-describedby="grid_m_id"]').html();
        var helper_ajax_parent = $(this).parents('tr:first');

        showAjaxLoading();
        $.ajax({
            type:"POST",
            url:"../php/getData2.php",
            dataType:"html",
            data: { keyVal: emplID, 'qryType' : 'getVKS'},
            success:function (tr) {
                checkSession(tr);
                tr = $.parseJSON(tr);
                hideAjaxLoading();
                $.create_popup_dialog(
                    tr['template'],
                    'Сменить номер ВКС',
                    function(){},
                    false,
                    function(popup_id){
                        var $popup_vks = $('#' + popup_id);
                        $popup_vks.find('.ui-dialog-buttonset').remove();
                        $popup_vks.find('form.form_set_VKS button[type="submit"]').button();
                        $popup_vks.find('form.form_set_VKS').submit(function(e) {
                            e.preventDefault();
                        }).validate({
                            onkeyup: function(element) {
                                $(element).val($.trim($(element).val()));
                                $(element).valid();
                            },
                            rules: {empl_vks: {number: true}},
                            messages: {empl_vks: {number: "Введите только числа"}},
                            submitHandler: function(form){
                                showAjaxLoading();
                                $(form).find('.button').blur();
                                $(form).find("input").prop("disabled", true);
                                $.ajax({
                                    url:"../php/getData2.php",
                                    type: "POST",
                                    dataType:'html',
                                    data: {
                                        'qryType' : 'setVKS',
                                        'm_id': $(form).find('input[name="m_id"]').val(),
                                        'empl_vks': $(form).find('input[name="empl_vks"]').val()
                                    },
                                    success: function(new_tr){
                                        checkSession(new_tr);
                                        new_tr = $.parseJSON(new_tr);
                                        $(helper_ajax_parent).find('span.ajax_change_vks').html(new_tr['empl_vks']);
                                        $popup_vks.find('tr.tr_delete').remove();
                                        $popup_vks.find('form.form_set_VKS table').append(new_tr['template']);
                                        hideAjaxLoading();
                                    }
                                });
                            }
                        });
                    }
                );
            }
        });
    });
};

$.dlgStaffBonus = function(formid, formEdit = false){
    var $grid   =  $('#grid'),
        rowId   = $grid.jqGrid('getGridParam', 'selrow'),
        rowData = $grid.jqGrid('getRowData', rowId),
        userData = $grid.jqGrid('getGridParam','userData');

    $(formid).find('#FormError').hide();
    var rightType = '-staffs';
    if(formEdit){
        if($.inArray(rowData['r_id'], userData['riks']) < 0 && $.inArray(rowData['d_id'], userData['districts']) < 0) {
            $(formid).find('#d_name').html('<option value="' + rowData['d_id'] + '">' +rowData['d_name'] +'</option>');
            $(formid).find('#rik_unit').html('<option value="' + rowData['r_id'] + '">' +rowData['r_name'] +'</option>');
            $(formid).find('#d_name select, #rik_unit select, #tr_stb_period select, #tr_stb_active input').prop('disabled', true);
            $('#sData').hide();
            $(formid).find('#FormError').css('display', 'block').find('td').html('Нет прав');
            return false;
        }

        $(formid).find('#rik_unit').addClass('grey');
        getRIKListByDistrict({disctrId: rowData['d_id'], i: '', rId: rowData['r_id'], childLvl: '', rikDD: false, rightType: rightType, preset_rId: rowData['r_id']});
        $(formid).find('#d_name').prop('disabled', true);
        $(formid).find('#rik_unit').prop('disabled', true);
        var rowMonth = rowData['stb_period'].split(' ')[0].toLowerCase(),
            rowYear = rowData['stb_period'].split(' ')[1];

        $("#stb_period_month").find("option:contains('"+rowMonth+"')").attr("selected", "selected");
        $("#stb_period_year").find("option:contains('"+rowYear+"')").attr("selected", "selected");
        if(rowData['stb_agreed'] === 'Yes'){
            $(formid).find('#tr_stb_period select, #tr_stb_active input').prop('disabled', true);
            $(formid).find('#FormError').css('display', 'block').find('td').html('Заявка согласована');
            $('#sData').hide();
        }
    } else {
        $(formid).find('#tr_stb_active').remove();
    }
    $('#d_name').change(function(){
        if($(this).val() !== ''){
            $(formid).find('#rik_unit').addClass('grey');
            getRIKListByDistrict({disctrId: $(this).val(), i: '', rId: -1, childLvl: '', rikDD: false, rightType: rightType});
        } else {
            $(formid).find('#rik_unit').prop('disabled', true).html('<option value="">Региональное отделение:</option>');
        }
    });
};

$.getAgreedBtn = function(rowid){
    var $grid   =  $('#grid'),
        rowId   = $grid.jqGrid('getGridParam', 'selrow'),
        rowData = $grid.jqGrid('getRowData', rowId),
        userData = $grid.jqGrid('getGridParam','userData');

    if($.inArray(rowData['r_id'], userData['riks']) < 0 && $.inArray(rowData['d_id'], userData['districts']) < 0) {
        $.create_popup_dialog('Нет прав', 'ошибка');
        return false;
    }

    if(rowData['stb_agreed'] === 'Yes'){
        $.create_popup_dialog('Заявка уже согласована', 'ошибка');
        return false;
    }
    if(rowData['stb_active'] !== 'Yes') {
        $.create_popup_dialog('У выбранной записи нет отметки "Документ активен"', 'ошибка');
        return false;
    }
    if(parseFloat(rowData['stbd_total_cost']) === 0){
        $.create_popup_dialog('У выбранной записи сумма заявки равна 0', 'ошибка');
        return false;
    }
    if(parseFloat(rowData['stbd_m_ids']) === 0){
        $.create_popup_dialog('У выбранной записи число единиц равно 0', 'ошибка');
        return false;
    }

    $.create_popup_dialog(
        $.templateBonusDlg(rowData),
        'Согласовать заявку?',
        -1,
        [{text: 'Да', func: function(){
                var that = this,
                    $stb_note_dlg = $('#stb_note_dlg');
                showAjaxLoading();
                $.ajax({
                    type:"POST",
                    url:"../php/tbl.BONUS.php",
                    dataType:"json",
                    data: {
                        'stb_note' : $.trim($stb_note_dlg.val()) ? $.trim($stb_note_dlg.val()) : null,
                        'stb_id' : rowid,
                        'stb_agreed': 'Yes',
                        'oper' : 'setAgreedDlg'
                    }, success:function (tr) {
                        hideAjaxLoading();
                        if(tr['status'] === 'fail'){
                            $.create_popup_dialog(tr['msg'], 'ошибка');
                            return false;
                        }

                        $(that).dialog('close');
                        $('#grid').trigger('reloadGrid');
                    }, error: function(err){
                        hideAjaxLoading();
                        $.create_popup_dialog(err, 'ошибка');
                        return false;
                    }
                });
            }}, {text: 'Нет', func: function(){
                $(this).dialog('close');
            }}],
        function(popup_id){
            $('#'+popup_id).find("#stb_note_dlg").keypress(function() {
                if (this.value.length > 250)
                    this.value = this.value.substr(0, 250);
            });
        }
    );
}

$.templateBonusDlg = function(tr){
    return ''+
        '<div style="width:400px;">' +
            '<div style="padding: 5px;">' +
                '<div>'+tr['r_name']+'</div>' +
            '</div>' +
            '<div style="padding: 5px;">' +
                '<div>Премиальный фонд на '+tr['stb_period']+'</div>' +
            '</div>' +
            '<div style="padding: 5px;">' +
                '<div>Число единиц: '+tr['stb_m_ids']+'</div>' +
            '</div>' +
            '<div style="padding: 5px;">' +
                '<div>Сумма заявки: '+tr['stb_total_cost']+'</div>' +
            '</div>' +
            '<div style="padding: 5px;">' +
                '<label for="stb_note_dlg" style="vertical-align:top;">Примечание:</label>' +
                '<textarea cols="40" rows="2" name="stb_note_dlg" id="stb_note_dlg"></textarea>' +
            '</div>' +
        '</div>';
};

$.getOGProcessBtn = function(rowid) {
    var $grid   =  $('#grid'),
        rowData = $grid.jqGrid('getRowData', rowid);

    showAjaxLoading();
    $.ajax({
        type:"POST",
        url:"../php/tbl.UIK.OG.TURNOUT.php",
        dataType:"json",
        data: {
            'uik_id' : rowid,
            'oper' : 'getProcess'
        }, success:function (responseData) {
            hideAjaxLoading();

            $.create_popup_dialog(
                $.templateOGProcessDlg(),
                'УИК № ' + rowData['uik_num'] + ' - явка',
                -1,
                [{text: 'Сохранить', func: function() {
                        var that = this,
                            ogProcessData = [],
                            tempData = {};

                        for (var cnt = 1; cnt <= 7; cnt++) {
                            $('div.ugp_process_table input[data-cnt="'+ cnt +'"]').each(function(k, elm) {
                                tempData[$(elm).attr('name')] = $(elm).val();
                            });
                            ogProcessData.push(tempData);
                            tempData = {};
                        }

                        ogProcessData = JSON.stringify(ogProcessData);
                        showAjaxLoading();
                        $.ajax({
                            type: 'POST',
                            url: 'https://erdb.edinros.ru/uik/setUikOgProcess.php',
                            dataType: 'json',
                            data: {
                                uik_id: rowid,
                                oper: 'setProcess',
                                data: ogProcessData,
                                m_guid: responseData['m_guid']
                            },
                            success:function (tr) {
                                hideAjaxLoading();

                                if(tr['status'] === 'fail') {
                                    $.create_popup_dialog(tr['msg'], 'ошибка');
                                    return false;
                                }

                                $(that).dialog('close');
                            }, error: function(err){
                                hideAjaxLoading();
                                $.create_popup_dialog(err, 'ошибка');
                                return false;
                            }
                        });
                    }}],
                function (popup_id) {
                    var $popup = $('#'+popup_id);
                    if(responseData['data'].length) {
                        for (var cnt = 1; cnt <= 7; cnt++) {
                            $popup.find('div.ugp_process_table input[type="number"][data-cnt="'+ cnt +'"]').each(function(k, elm) {
                                if(responseData['data'].hasOwnProperty((cnt-1))){
                                    $(elm).val(responseData['data'][cnt-1][$(elm).attr('name')]);
                                }
                            });
                        }
                    }

                    if(responseData['status'] === 'fail') {
                        $popup.find('span.og_for_error_rights').html(responseData['msg']);
                        $popup.find('span.og_for_error_rights').addClass('error-msg');
                        $popup.find('div.ugp_process_table input').prop('disabled', true);
                        $popup.find('button.f-right').hide();
                    }
                }
            );
        }, error: function(err){
            hideAjaxLoading();
            $.create_popup_dialog(err, 'ошибка');
            return false;
        }
    });
};

$.templateOGProcessDlg = function() {
    var  buildTable = '' +
        '<span class="og_for_error_rights"></span>' +
        '<div class="ugp_process_table">' +
            '<div class="ugp_process_table_row">' +
                '<div class="ugp_date"></div>' +
                '<div class="ugp_in_house_plan">Стационарное план</div>' +
                '<div class="ugp_out_house_plan">Выездное план</div>' +
                '<div class="ugp_in_house_real">Стационарное факт</div>' +
                '<div class="ugp_out_house_real">Выездное факт</div>' +
            '</div>';

    for (var cnt = 1; cnt <= 7; cnt++) {
        buildTable += '' +
            '<div class="ugp_process_table_row">' +
                '<div class="ugp_date">' +
                    ''+ $.getVoteDate(cnt, 'fullDate') +'' +
                    '<input type="hidden" data-cnt="'+ cnt +'" name="ugp_date" value="'+ $.getVoteDate(cnt, 'sqlDate') +'">' +
                    '<input type="hidden" data-cnt="'+ cnt +'" name="ugp_date_number" value="'+ cnt +'">' +
                '</div>' +
                '<div class="ugp_in_house_plan">' +
                    '<input data-cnt="'+ cnt +'" name="ugp_in_house_plan" class="ugp_in_house_plan_input" type="number" value="" min="0">' +
                '</div>' +
                '<div class="ugp_out_house_plan">' +
                    '<input data-cnt="'+ cnt +'" name="ugp_out_house_plan" class="ugp_out_house_plan_input" type="number" value="" min="0">' +
                '</div>' +
                '<div class="ugp_in_house_real">' +
                    '<input data-cnt="'+ cnt +'" name="ugp_in_house_real" class="ugp_in_house_real_input" type="number" value="" min="0">' +
                '</div>' +
                '<div class="ugp_out_house_real">' +
                    '<input data-cnt="'+ cnt +'" name="ugp_out_house_real" class="ugp_out_house_real_input" type="number" value="" min="0">' +
                '</div>' +
            '</div>';
    }

    buildTable += '</div>';

    return buildTable;
};

$.getVoteDate = function(voteDate, typeDate) {
    var arrayVoteDate = [{},
        {'fullDate': '25 июня', 'sqlDate': '2020-06-25'},
        {'fullDate': '26 июня', 'sqlDate': '2020-06-26'},
        {'fullDate': '27 июня', 'sqlDate': '2020-06-27'},
        {'fullDate': '28 июня', 'sqlDate': '2020-06-28'},
        {'fullDate': '29 июня', 'sqlDate': '2020-06-29'},
        {'fullDate': '30 июня', 'sqlDate': '2020-06-30'},
        {'fullDate': '1 июля',  'sqlDate': '2020-07-01'},
    ];

    return arrayVoteDate[voteDate][typeDate];
}

$.jqGridHistoryTurnout = function(params) {
    $(params.grid_id+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-history-turnout" title="История изменений \'Явки\'"><span class="ui-icon ui-icon-note"></span></div>');
    $(params.grid_id+" .ui-inline-history-turnout").on('click', function () {
        var rowid = $(this).parents('tr:first').attr('id'),
            $alertmodHistory = $("#alertmodHistory"),
            $historyDialog = $("#historyDialog");

        $historyDialog.html('');
        showAjaxLoading();
        $.ajax({
            type: "POST",
            url: params.url,
            dataType: "json",
            data: {
                'uik_id': rowid,
                'oper': params.oper
            },
            success: function (tr) {
                if (tr.error) {
                    $.create_popup_dialog(`<span class="error-msg">${tr.error}</span>`, 'Ошибка');
                    return false;
                }

                $alertmodHistory.find(".ui-jqdialog-title").html('История изменений "Явки"');
                $alertmodHistory.find(".ui-jqdialog-content").removeAttr('style');
                $alertmodHistory.css({'top': '5%', 'width': '725px', 'overflow-x': 'hide'});
                $alertmodHistory.css({left: ($(document).width() - $alertmodHistory.width())/2});

                $.jgrid.viewModal("#alertmodHistory", {});

                if (!tr.data) {
                    $historyDialog.html('Нет истории изменений');
                    return false;
                }

                showAjaxLoading();
                $.ajax({
                    type: "GET",
                    url: "php/tbl.TRACK.TURNOUT.php",
                    dataType: "html",
                    data: {
                        'keyName': params.prefix_id+'id',
                        'keyVal': "'" + tr.data + "'"
                    },
                    success: function (tr) {
                        $historyDialog.html(tr);
                    },
                    error: function (err) {
                        $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
                        return false;
                    }
                }).always(function (tr) {
                    hideAjaxLoading();
                    checkSession(tr);
                });

            },
            error: function (err) {
                $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
                return false;
            }
        }).always(function (tr) {
            hideAjaxLoading();
            checkSession(tr);
        });
    });
};

$.getOGStatisticBtn = function() {
    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_form" method="get" action="/php/excel.uik_og.php"></form>');
    $('#excel_uik_og_form').submit().remove();
};

$.getOGQualityBtn = function (){
    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_quality_form" method="get" action="/php/excel.uik_og_quality.php"></form>');
    $('#excel_uik_og_quality_form').submit().remove();
};

$.getOffenseTypeOG = function(){
    return '' +
        '<option value="Нарушение прав членов избирательной комиссии, наблюдателя, представителя СМИ">Нарушение прав членов избирательной комиссии, наблюдателя, представителя СМИ</option>' +
        '<option value="Незаконная выдача и получение бюллетеня, голосование более одного раза, выдача - заполненного бюллетеня">Незаконная выдача и получение бюллетеня, голосование более одного раза, выдача - заполненного бюллетеня</option>' +
        '<option value="Непредоставление сведений об итогах голосования или о результатах голосования участникам, наблюдателям, представителям СМИ">Непредоставление сведений об итогах голосования или о результатах голосования участникам, наблюдателям, представителям СМИ</option>' +
        '<option value="Вмешательство в работу избирательной комиссии, создание помех при голосовании, нарушение тайны голосования">Вмешательство в работу избирательной комиссии, создание помех при голосовании, нарушение тайны голосования</option>' +
        '<option value="Нарушения при определении итогов и результатов общероссийского голосования">Нарушения при определении итогов и результатов общероссийского голосования</option>' +
        '<option value="Иные нарушения">Иные нарушения</option>';
};

$.getOGTurnoutByRikBtn = function (){
    var $grid = $('#grid'),
        $postData = $grid.jqGrid('getGridParam', 'postData'),
        filtersFlag = false,
        rowsData = $grid.jqGrid('getRowData');

    if ($postData.filters) {
        $.each(JSON.parse($postData.filters)['rules'], function (k, v) {
            if (v['field'] === 'r_name') {
                filtersFlag = true;
            }
        });
    }

    if(!filtersFlag) {
        $.create_popup_dialog('Выберите фильтр РО', 'Ошибка');
        return false;
    }

    if(!rowsData.length){
        $.create_popup_dialog('Выберите другое РО', 'Ошибка');
        return false;
    }

    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_turnout_form" method="get" action="/php/excel.uik_og_turnout_by_rik.php" >' +
            '<input name="uik_og_filter" value="'+ rowsData[0].r_id +'">' +
        '</form>');
    $('#excel_uik_og_turnout_form').submit().remove();
};

$.getOGTurnoutBtn = function (){
    var $grid = $('#grid'),
        $postData = $grid.jqGrid('getGridParam', 'postData'),
        filtersFlag = false,
        rowsData = $grid.jqGrid('getRowData');

    if ($postData.filters) {
        $.each(JSON.parse($postData.filters)['rules'], function (k, v) {
            if (v['field'] === 'mo_name') {
                filtersFlag = true;
            }
        });
    }

    if(!filtersFlag) {
        $.create_popup_dialog('Выберите фильтр МО', 'Ошибка');
        return false;
    }

    if(!rowsData.length){
        $.create_popup_dialog('Выберите другое МО', 'Ошибка');
        return false;
    }

    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_turnout_form" method="get" action="/php/excel.uik_og_turnout.php" >' +
            '<input name="uik_og_filter" value="'+ rowsData[0].mo_id +'">' +
        '</form>');
    $('#excel_uik_og_turnout_form').submit().remove();
};

$.getOGTurnoutByRegionBtn = function(){
    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_turnout_by_region_form" method="get" action="/php/excel.uik_og_turnout_by_region.php" ></form>');
    $('#excel_uik_og_turnout_by_region_form').submit().remove();
};

$.getExcelImportTurnoutBtn = function () {
    var data_turnout = {tmplDirName: 'uik_og_import_day_turnout_excel'};
    $.create_popup_dialog(
        $.templateOGImportExcelDlg(),
        'Импорт дневной явки',
        false, //submit function
        [{
            text: 'Импортировать', func: function () {
                var currentValue = $("#excel_import_day_turnout_file").val().toLowerCase(),
                    extForExcelArray = currentValue.split('.'),
                    extForExcel = extForExcelArray[extForExcelArray.length - 1];

                if (extForExcel !== 'xlsx' || !currentValue) {
                    $.create_popup_dialog('Файл в формате *.xlsx', 'ошибка');
                    return false;
                }

                $('.excel-import-day-turnout-form').submit();
            }
        }], //custom buttons
        function (popup_id) {
            var $currentPopup = $('#'+popup_id);
            $currentPopup.css({width: '500px', left: '150px', top: 0});
            $.tipTipMy('#excel_import_day_turnout_file','Файл в формате *.xlsx');

            $currentPopup.find("#excel_import_day_turnout_file").on('change', function () {
                var currentValue = $(this).val().toLowerCase(),
                    extForExcelArray = currentValue.split('.'),
                    extForExcel = extForExcelArray[extForExcelArray.length - 1];

                if (extForExcel !== 'xlsx' || !currentValue) {
                    $.create_popup_dialog('Файл в формате *.xlsx,', 'ошибка');
                    return false;
                }
            });

            $('.excel-import-day-turnout-form').validate({
                ignoreTitle: true,
                submitHandler: function (form) {
                    showAjaxLoading();

                    $.ajaxFileUpload({
                        url: '../php/excel.import.day_turnout.php',
                        secureuri: false,
                        fileElementId: 'excel_import_day_turnout_file',
                        data: data_turnout,
                        dataType: 'json',
                        success: function (tr) {
                            hideAjaxLoading();
                            if (checkSession(tr) && typeof(tr.error) !== 'undefined') {
                                if (tr.error !== '') {
                                    $currentPopup.find('.work-res')
                                        .html('<div class="error-msg">' + tr.error + '</div>')
                                        .animateHighlight("#F9A598", 1000);
                                } else {
                                    $currentPopup.find('.work-res').html($('<span class="success-msg">'+ tr.msg +'</span>')).animateHighlight('#FAF000', 1000);
                                }
                            }
                        },
                        error: function (data, status, e) {
                            hideAjaxLoading();
                            $currentPopup.find('.work-res')
                                .html('<div class="error-msg">Ошибка. Обратитесь к администратору.</div>')
                                .animateHighlight("#F9A598", 1000);
                        }
                    });
                }
            });
        }, //open func
        false, //close func
        true //disable close overlay
    );
};

$.templateOGImportExcelDlg = function() {
    return '' +
        '<form class="excel-import-day-turnout-form">' +
        '<h3 class="field">Выберите excel-файл для импорта:</h3>' +
        '<span class="field">' +
        '<input type="file" size="51" id="excel_import_day_turnout_file" name="excel_import_day_turnout_file" class="required"><br>' +
        '</span>' +
        '<span class="work-res field">&nbsp;</span>' +
        '</form>';
};

$.getOGTurnoutByRikCSVBtn = function() {
    var $grid = $('#grid'),
        $postData = $grid.jqGrid('getGridParam', 'postData'),
        filtersFlag = false,
        rowsData = $grid.jqGrid('getRowData');

    if ($postData.filters) {
        $.each(JSON.parse($postData.filters)['rules'], function (k, v) {
            if (v['field'] === 'r_name') {
                filtersFlag = true;
            }
        });
    }

    if(!filtersFlag) {
        $.create_popup_dialog('Выберите фильтр РО', 'Ошибка');
        return false;
    }

    if(!rowsData.length){
        $.create_popup_dialog('Выберите другое РО', 'Ошибка');
        return false;
    }

    $('#work_panel_wrap').append(
        '<form id="excel_uik_og_turnout_by_rik_csv_form" method="get" action="/php/excel.uik_og_turnout_by_rik_csv.php" >' +
            '<input name="uik_og_filter" value="'+ rowsData[0].r_id +'">' +
        '</form>');
    $('#excel_uik_og_turnout_by_rik_csv_form').submit().remove();
};

$.getCsvImportDataBtn = function () {
    var data_csv = {tmplDirName: 'csv_import_file_tmpl'};
    $.create_popup_dialog(
        $.templateCsvImportDlg(),
        'Импорт',
        false, //submit function
        [{
            text: 'Импортировать', func: function () {
                $('.csv-import-site-mentions-form').submit();
            }
        }], //custom buttons
        function (popup_id) {
            var $currentPopup = $('#'+popup_id);
            $currentPopup.css({width: '500px', left: '150px', top: 0});

            $('.csv-import-site-mentions-form').validate({
                ignoreTitle: true,
                submitHandler: function (form) {
                    showAjaxLoading();

                    $.ajaxFileUpload({
                        url: '../php/csv.import.site_mentions.php',
                        secureuri: false,
                        fileElementId: 'csv_import_file',
                        data: data_csv,
                        dataType: 'json',
                        success: function (tr) {
                            hideAjaxLoading();
                            if (checkSession(tr) && typeof(tr.error) !== 'undefined') {
                                if (tr.error !== '') {
                                    $currentPopup.find('.work-res')
                                        .html('<div class="error-msg">' + tr.error + '</div>')
                                        .animateHighlight("#F9A598", 1000);
                                } else {
                                    $currentPopup.find('.work-res').html($('<span class="success-msg">'+ tr.msg +'</span>')).animateHighlight('#FAF000', 1000);
                                }
                            }
                        },
                        error: function (data, status, e) {
                            hideAjaxLoading();
                            $currentPopup.find('.work-res')
                                .html('<div class="error-msg">Ошибка. Обратитесь к администратору.</div>')
                                .animateHighlight("#F9A598", 1000);
                        }
                    });
                }
            });
        }, //open func
        false, //close func
        true //disable close overlay
    );
};

$.templateCsvImportDlg = function() {
    return '' +
        '<form class="csv-import-site-mentions-form">' +
        '<h3 class="field">Выберите excel-файл для импорта:</h3>' +
        '<span class="field">' +
        '<input type="file" size="51" id="csv_import_file" name="csv_import_file" class="required"><br>' +
        '</span>' +
        '<span class="work-res field">&nbsp;</span>' +
        '</form>';
};

$.afterShowFormOffenseList = function (formID, oper) {
    formID.find('td.CaptionTD').css('width', '220');
    formID.find('#tr_d_name td.CaptionTD').html('Федеральный округ');
    formID.find('#tr_r_reg_name td.CaptionTD').html('Субъект РФ');
    formID.find('#tr_cmp_name td.CaptionTD').html('Избирательная кампания');

    var $grid = $('#grid'),
        rowId = oper === 'edit' ? $grid.jqGrid('getGridParam', 'selrow') : -1,
        rowData = rowId > 0 ? $grid.jqGrid('getRowData', rowId) : {},
        cmp_id = -1,
        dElId = '#d_name',
        rikElId = '#r_reg_name',
        moElId = -1,
        poElId = -1,
        role = 'offense',
        section = '-offense',
        target = '#'+formID.attr('id');

    var enableFld = function (fld) {
        $(fld).parent().parent().show(500, function () {
            $(fld).parent().parent().animateHighlight("#FAF000", 500);
        }).find('input, select').prop('disabled', false);
    };

    var disableFld = function (fld) {
        $(fld).parent().parent().hide(500).find('input, select').val('').focusout().prop('disabled', true);
    };

    var prepareHideShowFields = function (target) {
        $.each([
            'ofs_fio', 'ofs_candidate_fio',
            'ofs_fio_dec', 'ofs_candidate_fio_dec',
            'ofs_date', 'ofs_period_start', 'ofs_period_end',
            'ofs_party_name', 'ofs_party_nominated',
            'ofs_party_name_dec', 'ofs_party_nominated_dec',
            'ofs_selective_association', 'ofs_selective_association_dec',
            'ofs_other_entity_destination', 'ofs_other_entity_destination_dec',
            'ofs_candidate_electoral_association', 'ofs_candidate_electoral_association_dec',
            'ofs_other_selective_association', 'ofs_other_selective_association_dec',
            'ofs_submission_subject', 'ofs_submission_subject_dec',
            'ofs_ik_name', 'ofs_ik_name_dec',
            'ofs_subject_offense_name', 'ofs_other_person_dec',
            'ofs_destination_ik', 'ofs_destination_law', 'ofs_destination_other'
        ], function (k,v) {
            $(target + ' #' + v).parent().parent().hide().find('input, select').val('').prop('disabled', true);
        });
    };

    prepareHideShowFields(target);

    $(dElId + ' option:first').prop('disabled', true);

    $.jqGridSetSelectorHandlers(rowId, dElId, rikElId, moElId, poElId, role, section);

    formID.find('#r_reg_name').on('change', function () {
        var $notValueOption = $(this).find('option:not([value=""])');
        if ($notValueOption.length === 1) {
            $notValueOption.prop('selected', true);
        }

        if ($(this).val() > 0) {
            showAjaxLoading();
            $.ajax({
                type:"POST",
                url:"php/getData.php",
                dataType:'json',
                data: {
                    qryType: 'getCampaigns',
                    disctrict0: formID.find('#d_name').val(),
                    rik_unit0: formID.find('#r_reg_name').val()
                },
                success: function (tr) {
                    if (tr.error !== '') {
                        $.create_popup_dialog(`<span class="error">${tr.error}</span>`, 'Ошибка');
                        return false;
                    }

                    if (rowData.hasOwnProperty('cmp_id')) {
                        cmp_id = isNaN(parseInt(rowData['cmp_id'])) ? 0 : parseInt(rowData['cmp_id']);
                    }

                    var campaignsOpt = '<option value="">Избирательная кампания:</option>';
                    $.each(tr.data, function (k, item) {
                        if (cmp_id === parseInt(item['cmp_id'])) {
                            campaignsOpt += '<option value="'+item.cmp_id+'" selected="selected">'+item.cmp_name+' ('+item.cmp_vote_date+')</option>';
                        } else {
                            campaignsOpt += '<option value="'+item.cmp_id+'">'+item.cmp_name+' ('+item.cmp_vote_date+')</option>';
                        }

                    });

                    formID.find('#cmp_name').html(campaignsOpt).addClass('grey').parent().animateHighlight("#FAF000", 1000);
                },
                error: function (err) {
                    $.create_popup_dialog(`<span class="error">${err}</span>`, 'Ошибка');
                    return false;
                }
            }).always(function (data) {
                hideAjaxLoading();
                checkSession(data);
            });
        } else {
            formID.find('#cmp_name')
                .html('<option role="option" value="-1"> </option>')
                .addClass('grey').parent().animateHighlight("#FAF000", 1000);
        }
    });

    $(target + ' #ofs_subject, ' + target + ' #ofs_declarer').change(function () {
        var postfix = '';
        if ($(this).attr('id') === 'ofs_declarer') {
            postfix = '_dec';
            disableFld(target + ' #ofs_other_person_dec');
        } else {
            disableFld(target + ' #ofs_subject_offense_name');
        }

        disableFld(
            target + ' #ofs_fio' + postfix + ', ' +
            target + ' #ofs_candidate_electoral_association' + postfix + ', ' +
            target + ' #ofs_candidate_fio' + postfix + ', ' +
            target + ' #ofs_party_name' + postfix + ', ' +
            target + ' #ofs_party_nominated' + postfix + ', ' +
            target + ' #ofs_ik_name' + postfix + ', ' +
            target + ' #ofs_submission_subject' + postfix + ', ' +
            target + ' #ofs_other_selective_association' + postfix + ', ' +
            target + ' #ofs_other_entity_destination' + postfix + ', ' +
            target + ' #ofs_selective_association' + postfix
        );

        if ($(this).val() === 'Избирательное объединение') {
            enableFld(target + ' #ofs_selective_association' + postfix);
        } else if ($(this).val() === 'Кандидат') {
            enableFld(
                target + ' #ofs_candidate_electoral_association' + postfix + ', ' +
                target + ' #ofs_fio' + postfix
            );
        } else if ($(this).val() === 'Избиратель') {
            enableFld(target + ' #ofs_fio' + postfix);
        } else if ($(this).val() === 'Наблюдатель') {
            enableFld(
                target + ' #ofs_submission_subject' + postfix + ', ' +
                target + ' #ofs_fio' + postfix
            );
        } else if ($(this).val() === 'Избирательная комиссия') {
            enableFld(target + ' #ofs_ik_name' + postfix);
        } else if ($(this).val() === 'Иной субъект нарушения') {
            enableFld(target + ' #ofs_subject_offense_name');
        } else if ($(this).val() === 'Иное лицо') {
            enableFld(target + ' #ofs_other_person_dec');
        }
    });

    $(target + ' #ofs_selective_association, ' + target + ' #ofs_selective_association_dec').change(function () {
        var postfix = '';
        if ($(this).attr('id') !== 'ofs_selective_association') {
            postfix = '_dec';
        }

        disableFld(
            target + ' #ofs_party_name' + postfix + ', ' +
            target + ' #ofs_other_entity_destination' + postfix
        );

        if ($(this).val() === 'Политическая партия') {
            enableFld(target+' #ofs_party_name'+postfix);
            $(target+' #ofs_party_name'+postfix).addClass('required');
        } else if ($(this).val() === 'Иное избирательное объединение') {
            enableFld(target+' #ofs_other_entity_destination'+postfix);
        }
    });

    $(target + ' #ofs_candidate_electoral_association, ' + target + ' #ofs_candidate_electoral_association_dec').change(function () {
        var postfix ='';
        if($(this).attr('id') === 'ofs_candidate_electoral_association_dec') {
            postfix = '_dec';
        }

        disableFld(
            target + ' #ofs_other_selective_association' + postfix + ', ' +
            target + ' #ofs_party_nominated' + postfix
        );

        if ($(this).val() === 'Политическая партия') {
            enableFld(target + ' #ofs_party_nominated' + postfix);
        } else if ($(this).val() === 'Иное избирательное объединение') {
            enableFld(target + ' #ofs_other_selective_association' + postfix);
        }
    });

    $(target + ' #ofs_submission_subject, ' + target + ' #ofs_submission_subject_dec').change(function () {
        var postfix = '';
        if ($(this).attr('id') !== 'ofs_submission_subject') {
            postfix = '_dec';
        }

        disableFld(
            target + ' #ofs_party_name' + postfix + ', ' +
            target + ' #ofs_candidate_fio' + postfix + ', ' +
            target + ' #ofs_candidate_electoral_association' + postfix + ', ' +
            target + ' #ofs_other_entity_destination' + postfix
        );

        if ($(this).val() === 'Политическая партия') {
            enableFld(target + ' #ofs_party_name' + postfix);
            $(target + ' #ofs_party_name' + postfix).addClass('required');
        } else if ($(this).val() === 'Кандидат') {
            enableFld(
                target + ' #ofs_candidate_fio' + postfix + ', ' +
                target + ' #ofs_candidate_electoral_association' + postfix
            );
        } else if ($(this).val() === 'Иное избирательное объединение') {
            enableFld(target + ' #ofs_other_entity_destination' + postfix);
        }
    });

    $(target + ' #ofs_destination_type').change(function () {
        disableFld(
            target + ' #ofs_destination_ik, ' +
            target + ' #ofs_destination_law, ' +
            target + ' #ofs_destination_procur, ' +
            target + ' #ofs_destination_internal, ' +
            target + ' #ofs_destination_other'+', ' +
            target + ' #ofs_destination_details'
        );

        if ($(this).val() === 'Избирательная комиссия') {
            enableFld(target + ' #ofs_destination_ik');
        } else if ($(this).val() === 'Суд') {
            enableFld(target + ' #ofs_destination_law');
        } else if ($(this).val() === 'Иной орган') {
            enableFld(target + ' #ofs_destination_other');
        }
    });

    $(target + ' #ofs_time_type').change(function () {
        if ($(this).val() === 'Дата') {
            disableFld(target + ' #ofs_period_start, ' + target + ' #ofs_period_end');
            enableFld(target + ' #ofs_date');
        } else if ($(this).val() === 'Период') {
            disableFld(target+' #ofs_date');
            enableFld(target+' #ofs_period_start, '+target+' #ofs_period_end');
        } else {
            disableFld(target + ' #ofs_date, ' + target + ' #ofs_period_start, ' + target + ' #ofs_period_end');
        }
    });

    if (oper === 'edit') {
        if (rowData['ofs_time_type'] === 'Дата') {
            enableFld(target+' #ofs_date');
            $(target+' #ofs_date').val(rowData['ofs_date']);
        } else if (rowData['ofs_time_type'] === 'Период') {
            enableFld(target+' #ofs_period_start, '+target+' #ofs_period_end');
            $(target+' #ofs_period_start').val(rowData['ofs_period_start']);
            $(target+' #ofs_period_end').val(rowData['ofs_period_end']);
        }

        var showFld = function(fld){
            $(fld).prop('disabled', false).parent().parent().show();
        };

        var buildCandidateElectoralAssociation = function(postfix){
            if(rowData['ofs_candidate_electoral_association'+postfix] === 'Политическая партия'){
                $(target+' #ofs_party_nominated'+postfix).val(rowData['ofs_party_nominated'+postfix]);
                showFld(target+' #ofs_party_nominated'+postfix);
            } else if(rowData['ofs_candidate_electoral_association'+postfix] === 'Иное избирательное объединение'){
                $(target+' #ofs_other_selective_association'+postfix).val(rowData['ofs_other_selective_association'+postfix]);
                showFld(target+' #ofs_other_selective_association'+postfix);
            }
        };

        var buildSubmissionSubject = function (postfix) {
            if (rowData['ofs_submission_subject'+postfix] === 'Кандидат') {
                $(target+' #ofs_candidate_fio'+postfix).val(rowData['ofs_candidate_fio'+postfix]);
                $(target+' #ofs_candidate_electoral_association'+postfix).val(rowData['ofs_candidate_electoral_association'+postfix]);
                showFld(target + ' #ofs_candidate_fio' + postfix + ', ' + target + ' #ofs_candidate_electoral_association' + postfix);
            } else if (rowData['ofs_submission_subject'+postfix] === 'Политическая партия') {
                $(target+' #ofs_party_name'+postfix).val(rowData['ofs_party_name'+postfix]);
                showFld(target+' #ofs_party_name'+postfix);
            } else if (rowData['ofs_submission_subject'+postfix] === 'Иное избирательное объединение') {
                $(target+' #ofs_other_entity_destination'+postfix).val(rowData['ofs_other_entity_destination'+postfix]);
                showFld(target+' #ofs_other_entity_destination'+postfix);
            }
        };

        var buildSubjectOrDeclarer = function (postfix) {
            var fieldName = (postfix === '' ? 'ofs_subject' : 'ofs_declarer');
            if (rowData[fieldName] === 'Избирательное объединение') {
                showFld(target+ ' #ofs_selective_association'+postfix);
                $(target+' #ofs_selective_association'+postfix).val(rowData['ofs_selective_association'+postfix]);
                if (rowData['ofs_selective_association'+postfix] === 'Иное избирательное объединение') {
                    showFld(target+ ' #ofs_other_entity_destination'+postfix);
                    $(target+' #ofs_other_entity_destination'+postfix).val(rowData['ofs_other_entity_destination'+postfix]);
                } else if (rowData['ofs_selective_association'+postfix] === 'Политическая партия') {
                    $(target+' #ofs_party_name'+postfix).val(rowData['ofs_party_name'+postfix]);
                    showFld(target+' #ofs_party_name'+postfix);
                }
            } else if (rowData[fieldName] === 'Кандидат') {
                $(target+' #ofs_fio'+postfix).val(rowData['ofs_fio'+postfix]);
                $(target+' #ofs_candidate_electoral_association'+postfix).val(rowData['ofs_candidate_electoral_association'+postfix]);
                showFld(target + ' #of_fio' + postfix + ', ' + target + ' #ofs_candidate_electoral_association' + postfix);
                buildCandidateElectoralAssociation(postfix);
            } else if (rowData[fieldName] === 'Наблюдатель') {
                $(target+' #ofs_fio'+postfix).val(rowData['ofs_fio'+postfix]);
                $(target+' #ofs_submission_subject'+postfix).val(rowData['ofs_submission_subject'+postfix]);
                showFld(target+' #ofs_fio'+postfix+', '+ target+' #ofs_submission_subject'+postfix);
                buildSubmissionSubject(postfix);
                buildCandidateElectoralAssociation(postfix);
            } else if (rowData[fieldName] === 'Избирательная комиссия') {
                $(target+' #ofs_ik_name'+postfix).val(rowData['ofs_ik_name'+postfix]);
                showFld(target+' #ofs_ik_name'+postfix);
            } else if (rowData[fieldName] === 'Иной субъект нарушения') {
                $(target+' #ofs_subject_offense_name').val(rowData['ofs_subject_offense_name']);
                showFld(target+' #ofs_subject_offense_name');
            } else if (rowData[fieldName] === 'Избиратель') {
                $(target+' #ofs_fio'+postfix).val(rowData['ofs_fio'+postfix]);
                showFld(target+' #ofs_fio'+postfix);
            }
        };

        buildSubjectOrDeclarer('');
        buildSubjectOrDeclarer('_dec');

        switch (rowData['ofs_destination_type']) {
            case 'Избирательная комиссия':
                $(target+' #ofs_destination_ik').val(rowData['ofs_destination_ik']);
                showFld(target+' #ofs_destination_ik');
                break;
            case 'Суд':
                $(target+' #ofs_destination_law').val(rowData['ofs_destination_law']);
                showFld(target+' #ofs_destination_law');
                break;
            case 'Иной орган':
                $(target+' #ofs_destination_other').val(rowData['ofs_destination_other']);
                showFld(target+' #ofs_destination_other');
                break;
            default:
                break;
        }
    }
};

$.beforeSubmitOffenseList = function (postdata, $form) {
    var result = [true],
        startPeriodDate = new Date($form.find('#ofs_period_start').datepicker('getDate')).getTime(),
        endPeriodDate = new Date($form.find('#ofs_period_end').datepicker('getDate')).getTime(),
        offenseDate = new Date($form.find('#ofs_date').datepicker('getDate')).getTime(),
        currentDate = new Date().getTime();

    if (startPeriodDate && endPeriodDate && startPeriodDate > endPeriodDate) {
        result = [false, 'Дата окончания периода должна быть больше даты начала'];
    } else if (startPeriodDate && startPeriodDate > currentDate ||
        endPeriodDate && endPeriodDate > currentDate ||
        offenseDate && offenseDate > currentDate) {
        result = [false, 'Ошибка валидации. Проверьте правильность ввода дат'];
    } else if (parseInt($form.find('#d_name')) <= 0) {
        result = [false, 'Федеральный округ: Неверные параметры запроса.'];
    } else if (parseInt($form.find('#r_reg_name')) <= 0) {
        result = [false, 'Субъект РФ: Неверные параметры запроса.'];
    } else if (parseInt($form.find('#cmp_name')) <= 0) {
        result = [false, 'Избирательная кампания: Неверные параметры запроса.'];
    } else if (!$.trim($form.find('#ofs_time_type').val())) {
        result = [false, 'Дата (период) совершения нарушения: Неверные параметры запроса.'];
    } else if ($form.find('#ofs_time_type').val() === 'Дата' && !$.trim($form.find('#ofs_date').val())) {
        result = [false, 'Дата (период) совершения нарушения: Неверные параметры запроса.'];
    } else if ($form.find('#ofs_time_type').val() === 'Период' && (!$.trim($form.find('#ofs_period_start').val()) || !$.trim($form.find('#ofs_period_end').val()))) {
        result = [false, 'Дата (период) совершения нарушения: Неверные параметры запроса.'];
    } else if (!$.trim($form.find('#ofs_type').val())) {
        result = [false, 'Вид нарушения: Неверные параметры запроса.'];
    } else if (!$.trim($form.find('#ofs_content').val())) {
        result = [false, 'Содержание нарушения: Неверные параметры запроса.'];
    }

    var validateOffenseSubject = function () {
        if (!$.trim($form.find('#ofs_subject').val())) {
            result = [false, 'Субъект нарушения: Неверные параметры запроса.'];
        } else if ($form.find('#ofs_subject').val() === 'Избирательное объединение') {
            if (!$form.find('#ofs_selective_association').val()) {
                result = [false, 'Избирательное объединение: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_selective_association').val() === 'Политическая партия' && !$form.find('#ofs_party_name').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_selective_association').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_entity_destination').val()) {
                result = [false, 'Избирательное объединение: Неверные параметры запроса.'];
            }
        } else if ($form.find('#ofs_subject').val() === 'Иной субъект нарушения' && !$form.find('#ofs_subject_offense_name').val()) {
            result = [false, 'Иной субъект нарушения: Неверные параметры запроса.'];
        } else if ($form.find('#ofs_subject').val() === 'Кандидат') {
            if (!$form.find('#ofs_fio').val()) {
                result = [false, 'ФИО кандидата: Неверные параметры запроса.'];
            } else if (!$form.find('#ofs_candidate_electoral_association').val()) {
                result = [false, 'Субъект выдвижения кандидата: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_candidate_electoral_association').val() === 'Политическая партия' && !$form.find('#ofs_party_nominated').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_candidate_electoral_association').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_selective_association').val()) {
                result = [false, 'Иное избирательное объединение: Неверные параметры запроса.'];
            }
        } else if ($form.find('#ofs_subject').val() === 'Наблюдатель') {
            if (!$form.find('#ofs_fio').val()) {
                result = [false, 'ФИО наблюдателя: Неверные параметры запроса.'];
            } else if (!$form.find('#ofs_submission_subject').val()) {
                result = [false, 'Субъект направления: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_submission_subject').val() === 'Политическая партия' && !$form.find('#ofs_party_name').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_submission_subject').val() === 'Кандидат') {
                if (!$form.find('#ofs_candidate_fio').val()) {
                    result = [false, 'ФИО кандидата: Неверные параметры запроса.'];
                } else if (!$form.find('#ofs_candidate_electoral_association').val()) {
                    result = [false, 'Субъект выдвижения кандидата: Неверные параметры запроса.'];
                } else if ($form.find('#ofs_candidate_electoral_association').val() === 'Политическая партия' && !$form.find('#ofs_party_nominated').val()) {
                    result = [false, 'Политическая партия: Неверные параметры запроса.'];
                } else if ($form.find('#ofs_candidate_electoral_association').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_selective_association').val()) {
                    result = [false, 'Иное избирательное объединение: Неверные параметры запроса.'];
                }
            }
        } else if ($form.find('#ofs_subject').val() === 'Избирательная комиссия') {
            if (!$form.find('#ofs_ik_name').val()) {
                result = [false, 'Избирательная комиссия: Неверные параметры запроса.'];
            }
        }
    };

    var validateOffenseDeclarer = function () {
        if (!$form.find('#ofs_declarer').val()) {
            result = [false, 'Заявитель: Неверные параметры запроса.'];
        } else if ($form.find('#ofs_declarer').val() === 'Избирательное объединение') {
            if (!$form.find('#ofs_selective_association_dec').val()) {
                result = [false, 'Избирательное объединение: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_selective_association_dec').val() === 'Политическая партия' && !$form.find('#ofs_party_name_dec').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_selective_association_dec').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_entity_destination_dec').val()) {
                result = [false, 'Избирательное объединение: Неверные параметры запроса.'];
            }
        } else if ($form.find('#ofs_declarer').val() === 'Избиратель' && !$form.find('#ofs_fio_dec').val()) {
            result = [false, 'Избиратель: Неверные параметры запроса.'];
        } else if ($form.find('#ofs_declarer').val() === 'Кандидат') {
            if (!$form.find('#ofs_fio_dec').val()) {
                result = [false, 'ФИО кандидата: Неверные параметры запроса.'];
            } else if (!$form.find('#ofs_candidate_electoral_association_dec').val()) {
                result = [false, 'Субъект выдвижения кандидата: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_candidate_electoral_association_dec').val() === 'Политическая партия' && !$form.find('#ofs_party_nominated_dec').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_candidate_electoral_association_dec').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_selective_association_dec').val()) {
                result = [false, 'Иное избирательное объединение: Неверные параметры запроса.'];
            }
        } else if ($form.find('#ofs_declarer').val() === 'Наблюдатель') {
            if (!$form.find('#ofs_fio_dec').val()) {
                result = [false, 'ФИО наблюдателя: Неверные параметры запроса.'];
            } else if (!$form.find('#ofs_submission_subject_dec').val()) {
                result = [false, 'Субъект направления: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_submission_subject_dec').val() === 'Политическая партия' && !$form.find('#ofs_party_name_dec').val()) {
                result = [false, 'Политическая партия: Неверные параметры запроса.'];
            } else if ($form.find('#ofs_submission_subject_dec').val() === 'Кандидат') {
                if (!$form.find('#ofs_candidate_fio_dec').val()) {
                    result = [false, 'ФИО кандидата: Неверные параметры запроса.'];
                } else if (!$form.find('#ofs_candidate_electoral_association_dec').val()) {
                    result = [false, 'Субъект выдвижения кандидата: Неверные параметры запроса.'];
                } else if ($form.find('#ofs_candidate_electoral_association_dec').val() === 'Политическая партия' && !$form.find('#ofs_party_nominated_dec').val()) {
                    result = [false, 'Политическая партия: Неверные параметры запроса.'];
                } else if ($form.find('#ofs_candidate_electoral_association_dec').val() === 'Иное избирательное объединение' && !$form.find('#ofs_other_selective_association_dec').val()) {
                    result = [false, 'Иное избирательное объединение: Неверные параметры запроса.'];
                }
            }
        } else if ($form.find('#ofs_declarer').val() === 'Избирательная комиссия') {
            if (!$form.find('#ofs_ik_name_dec').val()) {
                result = [false, 'Избирательная комиссия: Неверные параметры запроса.'];
            }
        }
    };

    validateOffenseSubject();
    validateOffenseDeclarer();

    return result;
};

$.showOffenseDetails = function () {
    $("#grid .offense_declarer, #grid .offense_subject").on('click', function () {
        if ($.trim($(this).html()) === '' || $.trim($(this).html()) === '&nbsp;') {
            return false;
        }

        var postfix = $(this).hasClass('offense_subject') ? '' : '_dec',
            ofsId = $(this).parents('tr:first').attr('id'),
            ofsCellVal = $(this).html(),
            ofsSelectiveAssociation = $('#grid').jqGrid('getRowData', ofsId)['ofs_selective_association'+postfix];

        $("#alertmodHistory .ui-jqdialog-title").html(postfix === '_dec' ? 'Сведения о заявителе' : 'Субъект нарушения');
        showAjaxLoading();
        $.ajax({
            type: "GET",
            url: "php/tbl.OFFENSE.DTL.php",
            dataType: "html",
            data: {
                postfix: postfix,
                ofsId: ofsId,
                cellVal: ofsCellVal,
                ofs_selective_association: ofsSelectiveAssociation
            },
            success:function (tr) {
                $("#historyDialog").html(tr);
            },
            error: function (err) {
                $.create_popup_dialog(`<span class="error">${err}</span>`, 'Ошибка');
                return false;
            }
        }).always(function () {
            hideAjaxLoading();
        });
    });
};

$.getUIKACProcessBtn = function (rowid) {
    var rowData = $('#grid').jqGrid('getRowData', rowid),
        validate_rules = {min: true, digits: true, number: true, range: true};

    showAjaxLoading();
    $.ajax({
        type: "POST",
        url: "php/tbl.UIK.AC.TURNOUT.php",
        dataType: "json",
        data: {
            'uik_id': rowid,
            'oper': 'getACTurnoutProcess'
        },
        success:function (res) {
            $.create_popup_dialog(
                $.templateUIKACProcessDlg(res),
                'УИК № ' + rowData['uik_num'] + ' - явка',
                false,
                [{text: 'Сохранить', func: function () {
                        var $form = $('#uik_ac_process_form'),
                            $form_error = $('#uik_ac_process_form_error'),
                            form_valid = true;

                        $.each($form.find('input.number'), function () {
                            if (this.validationMessage !== 'undefined' && this.validationMessage !== '') {
                                form_valid = false;
                                $form_error.empty().append('<span class="error-msg">Допускаются положительные числа</span>');
                                return false;
                            }
                        });

                        if ($form.valid() && form_valid) {
                            showAjaxLoading();
                            $form.submit();
                        } else {
                            $form_error.show();
                        }
                    }}],
                function (popup_id) {
                    var $form = $('#'+popup_id+' #uik_ac_process_form');

                    if (res.error) {
                        $form.find('input').attr('disabled', true);
                        $form.parent().parent().find('div.ui-dialog-buttonset').hide();
                    }

                    $form.validate({
                        wrapper: 'div',
                        errorClass: 'error-msg',
                        errorLabelContainer: "#uik_ac_process_form_error",
                        ignoreTitle: true,
                        keyup: true,
                        rules: {
                            'uac_turnout[2020-09-02]': validate_rules,
                            'uac_turnout[2020-09-03]': validate_rules,
                            'uac_turnout[2020-09-04]': validate_rules,
                            'uac_turnout[2020-09-05]': validate_rules,
                            'uac_turnout[2020-09-06]': validate_rules,
                            'uac_turnout[2020-09-07]': validate_rules,
                            'uac_turnout[2020-09-08]': validate_rules,
                            'uac_turnout[2020-09-09]': validate_rules,
                            'uac_turnout[2020-09-10]': validate_rules
                        },
                        submitHandler: function (form) {
                            var data = $('#uik_ac_process_form').serializeArray(),
                                turnout_sum = 0,
                                save_turnout_url = parseInt(res.is_local) === 1 ? 'uikedinrosru/setUikAcProcess.php' : 'https://erdb.edinros.ru/uik/setUikAcProcess.php';
                            data.push({name: 'oper', value: 'setProcess'});
                            data.push({name: 'is_local', value: res.is_local});
                            $.ajax({
                                url: save_turnout_url,
                                type: "POST",
                                data: data,
                                dataType: 'json',
                                success: function (tr) {
                                    if (tr.error) {
                                        $.create_popup_dialog(`<span class="error-msg">${tr.error}</span>`, 'Ошибка');
                                        return false;
                                    }

                                    $.create_popup_dialog(`<span class="success-msg">Данные успешно сохранены</span>`, 'Сообщение');
                                    $form.parent().dialog('close');
                                    $.each($form.find('input[type="number"]'), function (idx, item) {
                                        $('#'+rowid+' td.'+$(item).attr('data-turnout-date')).html($(item).val() === '' ? '' : parseInt($(item).val()));
                                        turnout_sum += parseInt($(item).val() === '' ? 0 : $(item).val());
                                    });
                                    $('#'+rowid+' td.uap_turnout_sum').html(turnout_sum);
                                },
                                error: function (err) {
                                    $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
                                    return false;
                                }
                            }).always(function (data) {
                                hideAjaxLoading();
                                checkSession(data);
                            });
                        },
                        showErrors: function (errorMap, errorList) {
                            $.each(errorList, function (k, elm) {
                                elm.message = $(elm.element).parent().prev().html() + ": Введите положительное число";
                            });
                            this.defaultShowErrors();
                        },
                    });
                }
            );
        },
        error: function (err) {
            $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
            return false;
        }
    }).always(function (data) {
        hideAjaxLoading();
        checkSession(data);
    });
};

$.templateUIKACProcessDlg = function (resData) {
    var html_form = '' +
            '<li class="uik_ac_process_error_container"><div id="uik_ac_process_form_error"></div></li>' +
            '<form id="uik_ac_process_form" method="post" action="">' +
                '<input type="hidden" name="uik_id" value="'+resData.uik_id+'">' +
                '<input type="hidden" name="m_guid" value="'+resData.m_guid+'">' +
                '<table>';

    for (var cnt = 0; cnt <= 8; cnt++) {
        var uap_turnout = isNaN(parseInt(resData.data[cnt].uap_turnout)) ? '' : resData.data[cnt].uap_turnout,
            uap_date = resData.data[cnt].uap_date;
        html_form += '' +
            '<tr>' +
                '<td class="uap_date_uik_ac_process">'+(2+cnt)+' сентября</td>' +
                '<td class="uap_turnout_uik_ac_process">' +
                    '<input type="number" min="0" step="1" class="number range" ' +
                        'name="uap_turnout['+uap_date+']" ' +
                        'value="'+uap_turnout+'" ' +
                        'data-turnout-date="'+uap_date+'">' +
                '</td>' +
            '</tr>';
    }

    html_form += '</table></form>';

    return html_form;
};

$.urlify = function (text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
        return '<a target="_blank" href="' + url + '">' + url + '</a>';
    })
}

$.getACTurnoutByRikBtn = function () {
    var $grid = $('#grid'),
        $postData = $grid.jqGrid('getGridParam', 'postData'),
        filtersFlag = false,
        rowsData = $grid.jqGrid('getRowData');

    if ($postData.filters) {
        $.each(JSON.parse($postData.filters)['rules'], function (k, v) {
            if (v['field'] === 'r_name') {
                filtersFlag = true;
            }
        });
    }

    if(!filtersFlag) {
        $.create_popup_dialog('Выберите фильтр РО', 'Ошибка');
        return false;
    }

    if (!rowsData.length) {
        $.create_popup_dialog('Выберите другое РО', 'Ошибка');
        return false;
    }

    $('#work_panel_wrap').append(
        '<form id="excel_uik_ac_turnout_form" method="get" action="/php/excel.uik_ac_turnout_by_rik.php" >' +
        '<input name="uik_ac_filter" value="'+ rowsData[0].r_id +'">' +
        '</form>');
    $('#excel_uik_ac_turnout_form').submit().remove();
};

$.getACTurnoutByRegionBtn = function() {
    $('#work_panel_wrap').append(
        '<form id="uik_ac_turnout_federal_form" method="get" action="/php/excel.uik_ac_turnout_federal.php" ></form>');
    $('#uik_ac_turnout_federal_form').submit().remove();
};

$.checkMegaSearchForm = function ($popupDialog) {
    var search_type = [],
        db_erdb = {}, db_m10n = {}, db_agitator = {},
        ms_name = $.trim($popupDialog.find('#mega_search_name').val()),
        ms_surname = $.trim($popupDialog.find('#mega_search_surname').val()),
        ms_middlename = $.trim($popupDialog.find('#mega_search_middlename').val()),
        ms_bday = $.convertDateForSQL($.trim($popupDialog.find('#mega_search_bday').val())),
        ms_phone_mobile = $popupDialog.find('#mega_search_phone_mobile').val(),
        ms_passport_serial = $.trim($.returnOnlyNumbers($popupDialog.find('#mega_search_passport_serial').val())),
        ms_passport_number = $.trim($.returnOnlyNumbers($popupDialog.find('#mega_search_passport_number').val())),
        ms_party_card_number = $.trim($.returnOnlyNumbers($popupDialog.find('#mega_search_party_card_number').val()));

    if (ms_name !== '' && ms_surname !== '' && ms_middlename !== '') {
        search_type.push('fio');
        db_erdb["m_name"] = ms_name;
        db_erdb["m_surname"] = ms_surname;
        db_erdb["m_middlename"] = ms_middlename;
        db_m10n["first_name"] = ms_name;
        db_m10n["last_name"] = ms_surname;
        db_m10n["patronymic"] = ms_middlename;
        db_agitator["first_name"] = ms_name;
        db_agitator["last_name"] = ms_surname;
        db_agitator["patronymic"] = ms_middlename;

        if (ms_bday) {
            db_erdb['m_bday'] = ms_bday;
            db_m10n['birthday'] = ms_bday;
        }
    }

    if ($.trim($.returnOnlyNumbers(ms_phone_mobile)) !== '') {
        search_type.push('phone');
        db_erdb["m_phone_mobile"] = $.trim($.returnOnlyNumbers(ms_phone_mobile).slice(1));
        db_m10n["phone_mobile"] = $.trim(ms_phone_mobile.slice(3));
        db_agitator["phone"] = $.trim($.returnOnlyNumbers(ms_phone_mobile).slice(1));
    }

    if (ms_passport_serial !== '' && ms_passport_number !== '') {
        search_type.push('passport');
        db_erdb["m_passport_series"] = ms_passport_serial;
        db_erdb["m_passport_num"] = ms_passport_number;
    }

    if (ms_party_card_number !== '') {
        search_type.push('party_card');
        db_erdb["m_party_card_number"] = ms_party_card_number;
    }


    return {
        search_type: search_type,
        rules: {
            'erdb': db_erdb,
            'm10n': db_m10n,
            'agitator': db_agitator
        }
    };
};

$.getAddMegaSearchBtn = function () {
    var $bday, $popupDialog,
        $form, $grid = $("#grid"),
        filters = {};

    $.create_popup_dialog(
        $('#mega_search_tmpl').html().replace(/\{TMPL\}/g, ''),
        'Условие для поиска',
        false,
        [{
            text: 'Поиск',
            func: function () {
                filters = $.checkMegaSearchForm($popupDialog);
                if (filters.hasOwnProperty('rules') && filters.hasOwnProperty('search_type') && filters.search_type.length) {
                    $form.find('table tr:first td').addClass('hidden');
                    $form.submit();
                } else {
                    $form.find('table tr:first td').removeClass('hidden');
                }
            }}],
        function (popup_id) {
            $popupDialog = $('#'+popup_id);
            $form = $popupDialog.find('#mega_search_form');
            $popupDialog.find('#mega_search_passport_serial').mask('99-99');
            $popupDialog.find('#mega_search_passport_number').mask('999999');
            $popupDialog.find('#mega_search_phone_mobile').mask('+7 (999) 999-99-99');
            $popupDialog.find('#mega_search_party_card_number').mask('9999 9999');
            $bday = $popupDialog.find('#mega_search_bday');
            $bday.datepicker({
                dateFormat: "dd.mm.yy",
                changeMonth: true,
                changeYear: true,
                showAnim: "slideDown",
                yearRange: '-100',
                minDate: new Date(1900, 1, 1)
            }).change(function () {
                $bday.keydown();
            });

            $form.validate({
                ignoreTitle: true,
                submitHandler: function (form) {
                    $form.parent().dialog('close');
                    $grid.jqGrid('setGridParam', {
                        search: true,
                        postData: {
                            filters: JSON.stringify({
                                groupOp: "AND",
                                rules: [],
                                search_rules: filters.rules,
                                search_type: filters.search_type
                            })
                        }
                    }).trigger("reloadGrid");
                }
            });
        }
    );
};

$.returnOnlyNumbers = function (value) {
    return value ? value.replace(/\D+/g, '') : '';
};

$.convertDateForSQL = function (d) {
    if ((d.match(/\./g) || []).length !== 2)  {
        return false;
    }

    var returnDate = d.split('.');

    if (typeof returnDate[0] !== 'undefined' && $.isNumeric(returnDate[0]) &&
        typeof returnDate[1] !== 'undefined' && $.isNumeric(returnDate[1]) &&
        typeof returnDate[2] !== 'undefined' && $.isNumeric(returnDate[2])) {
        return returnDate[2] + '-' + returnDate[1] + '-' + returnDate[0];
    }

    return false;
};

$.currentGridViewToExcel = () => {
    const clonedGrid = $('<div class="cloned-grid"></div>')
        .append($('.ui-jqgrid-htable').clone())
        .append($('#grid').clone());
    clonedGrid.appendTo('body');
    clonedGrid.find('.ui-search-toolbar, th:hidden, td:hidden').remove();
    tableToExcel('.cloned-grid');
    clonedGrid.remove();
};

var strip_tags_custom = function (html) {
    let divElement = document.createElement('DIV'),
        stripped = '',
        count = 0;

    divElement.innerHTML = html;

    do {
        stripped = divElement.innerText;
        divElement.innerHTML = divElement.innerText;
        count++;
        if (count > 10) {
            break;
        }
    } while (divElement.innerText != stripped)

    return divElement.innerText || '';
};

var isNumber = value => {
    if (value instanceof Number) {
        value = value.valueOf();
    }

    return isFinite(value) && !isNaN(parseInt(value, 10));
};

var checkCanBeAssistant = (formID, assistants) => {
    let returnValue = '';

    if ($(formID).find('#id_g').val() === $(formID).find('#m_assist_deputy_id').val()) {
        return 'Персоналий не может быть помощником у самого себя';
    }

    if ($('#m_sf_deputy').val() === 'Yes' && $('#m_sf_deputy_rik_id').val() > 0) {
        $.each(assistants, (idx, assistant) => {
            if ($(formID).find('#' + assistant).prop('checked')) {
                returnValue = 'Сенатор РФ: Сенатор не может быть помощником';
            }
        });
    }

    return returnValue;
};

var getAllowedUploadFilesExt = params => {
    const imagesExt = params.img ? ['jpg','jpeg','png','bmp','gif','tiff','webp'] : [],
        msOfficeExt = params.office ? ['doc','docx','xls','xlsx','pppt','ppptx'] : [],
        pdfExt = params.pdf ? ['pdf'] : [];

    return [...imagesExt, ...msOfficeExt, ...pdfExt];
};

var purifyUploadNameFile = fileName => {
    if (typeof fileName !== 'string') {
        return '';
    }

    if (!fileName.length) {
        return '';
    }

    let cleanFileName = fileName.replace(/[^а-яёa-z_\s\d.-]+/igu, '');

    if (!cleanFileName.length ||
        !cleanFileName.includes('.') ||
        !checkFileNameWithoutExt(cleanFileName)
    ) {
        return '';
    }

    return cleanFileName;
};

var extBlackList = () => {
    return [
        'php', 'phtml', 'php3', 'php4',
        'js', 'sql'
    ];
};

var getFileNameWithoutExt = fileName => {
    fileName = fileName.split('.');
    fileName.pop();
    return fileName.join('.');
};

var checkFileNameWithoutExt = fileName => {
    const fileNameWithoutExt = getFileNameWithoutExt(fileName).trim();
    if (fileNameWithoutExt === '' || fileNameWithoutExt[0].match(/[^а-яёa-z\d.]+/igu)) {
        return false;
    }
    return true;
};

/**
 * Устанавливает Datepicker
 *
 * вызов с параметрами: elem_selector => datepickerForFilterOptions(elem_selector, {foo: 'bar'})
 *
 * @param {string} elem - селектор элемента
 * @param {object} options - конфиг Datepicker (https://api.jqueryui.com/datepicker/)
 */
function datepickerForFilterOptions (elem, options = {}) {
    const defaultOptions = {
        dateFormat: 'dd.mm.yy',
        changeMonth: true,
        changeYear: true,
        showAnim: 'slideDown',
        yearRange: '-100',
        showButtonPanel: true
    }

    $(elem).datepicker(Object.assign(defaultOptions, options)).change(
        function(){
            $(this).keydown();
        }
    );
}

function datepickerForEditOptions (elem, options = {}) {
    const defaultOptions = {
        dateFormat: 'dd.mm.yy',
        changeMonth: true,
        changeYear: true,
    };

    setTimeout(() => $(elem).datepicker(Object.assign(defaultOptions, options)), 200);
}

const postDateFieldWrapper = (postData, grid_id) => {
    let data = JSON.parse(postData.filters);
    let dateFields;
    let grid;

    if (grid_id === '#grid' && typeof postData.subgrid !== 'undefined') {
        grid = $('#' + postData.subgrid + ' .ui-jqgrid-btable');
    } else {
        grid = $(grid_id);
    }

    if (!grid.getGridParam('dateFields')) {
        dateFields = grid.getGridParam('colModel').reduce((result, column) => {
            if (column['formatter'] === 'date') {
                result.push(column['name']);
            }
            return result;
        }, []);
        grid.setGridParam({dateFields});
    } else {
        dateFields = grid.getGridParam('dateFields');
    }

    data.rules = data.rules.map(rule => {
        if (dateFields.includes(rule['field'])) {
            rule['data'] = rule['data'].replace(/^(\d{2})\.(\d{2}).(\d{4})$/,'$3-$2-$1');
            rule['field'] = 'date('+rule['field']+')';
        }
        return rule;
    });

    postData.filters = JSON.stringify(data);
};

const replaceNToBrOnly = (cellValue, options, rowObject) => cellValue.replace(/\n/g, '<br>');

const replaceBrToNOnly = (cellValue, options, cellObject) => cellObject.html().replace(/<br>/g,'\n');

const convertDataForUserView = (key, value) => {
    if (value === null || value.trim() === '') {
        return '';
    }
    if (value === 'Yes' || value === 'true' || value === 't' || value === 'on') {
        return 'Да';
    }
    if (value === 'No' || value === 'false' || value === 'f' || value === 'off') {
        return 'Нет';
    }
    if (key === 'm_passport_series' && /\d{4}/.test(value)) {
        return value.replace(/(\d{2})(\d{2})/, '$1 $2');
    }
    if (key === 'm_party_card_number' && /\d{8}/.test(value)) {
        return value.replace(/(\d{4})(\d{4})/, '$1 $2');
    }
    if (['m_phone_mobile', 'm_phone_work', 'm_phone_alt', 'm_phone_office', 'm_phone_mobile_wrong'].includes(key) && /\d{10}/.test(value)) {
        return value.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 ($1) $2-$3-$4');
    }
    // convert date
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1');
    }

    if (key === 'm_data_h' && /"=>"/.test(value)) {
        try {
            JSON.parse('{' + value.replaceAll('"=>"', '":"') + '}');
        }
        catch(err) {
            return value;
        }

        if (value === '"auto_added"=>"true"') {
            return 'Да';
        }

        let dataHJson = JSON.parse('{' + value.replaceAll('"=>"', '":"') + '}');
        const emplValidValues = {
            empl_phone_work_ext: 'Внутренний номер',
            empl_email_work: 'Служебный email',
            empl_email: 'Личный email',
            empl_phone_work: 'Рабочий телефон',
            empl_phone_mobile: 'Мобильный телефон',
            empl_phone_addition: 'Дополнительный телефон',
            empl_certificate: 'Номер удостоверения',
            empl_facebook: 'Профиль в Facebook',
            empl_vkontakte: 'Профиль в VKontakte',
            empl_odnoklassniki: 'Профиль в Одноклассниках',
            empl_twitter: 'Профиль в Twitter',
            empl_website: 'Веб-сайт',
            empl_icq: 'ICQ-номер',
            empl_skype: 'Skype',
            empl_jabber: 'Jabber',
            empl_address: 'Адрес',
            empl_room_num: 'Номер комнаты',
            empl_comment: 'Комментарий'
        };
        let html = '<table class="membMergeTable">';
        let classFlag = true;
        $.each(dataHJson, function(k,v){
            if (k in emplValidValues && v !== '') {
                html += '<tr class=\"'+(classFlag ? 'subgridRowAlt' : '')+'\">';
                html += '<td class="membMergeTable__cell '+k+'">'+emplValidValues[k]+'</td><td class="membMergeTable__cell '+k+'_value">'+v+'</td>';
                html += '</tr>';
                classFlag = !classFlag;
            }
        });
        html += '</table>';
        return html;
    }

    if (['m_personal_profession', 'm_personal_education', 'm_personal_labor_activity', 'm_socio_political_activities', 'm_public_organization_info'].includes(key)) {
        try {
            JSON.parse(value);
        }
        catch(err) {
            return value;
        }

        let parsedValue = JSON.parse(value);
        let html = '';

        if (parsedValue && parsedValue[0] && parsedValue[0][0]) {
            if(parsedValue[0][0].name.substr(0,4) == 'mpp_'){
                html += '<table class="membMergeTable"><thead><tr><th class="membMergeTable__head_text">Специальность по диплому</th></tr></thead>';
            } else if(parsedValue[0][0].name.substr(0,4) == 'mpe_') {
                html += '<table class="membMergeTable"><thead><tr><th class="membMergeTable__head_text">Уч.заведение</th><th class="membMergeTable__head_date">Поступление&nbsp;</th><th class="membMergeTable__head_date">Окончание&nbsp;</th><th class="membMergeTable__head_text">Специальность</th></tr></thead>';
            } else if(parsedValue[0][0].name.substr(0,4) == 'mpla') {
                html += '<table class="membMergeTable"><thead><tr><th class="membMergeTable__head_text">Должность и место работы</th><th class="membMergeTable__head_date">Поступления&nbsp;</th><th class="membMergeTable__head_date">Увольнения&nbsp;</th></tr></thead>';
            } else if(parsedValue[0][0].name.substr(0,4) == 'mspa') {
                html += '<table class="membMergeTable"><thead><tr><th class="membMergeTable__head_text">Деятельность</th><th class="membMergeTable__head_date">Начало&nbsp;</th><th class="membMergeTable__head_date">Окончание&nbsp;</th></tr></thead>';
            } else if(parsedValue[0][0].name.substr(0,4) == 'mpoi') {
                html += '<table class="membMergeTable"><thead><tr><th class="membMergeTable__head_text">Вид организации</th><th class="membMergeTable__head_text">Название организации</th><th class="membMergeTable__head_text">Статус в организации</th></tr></thead>';
            }
        }

        $.each(parsedValue, function(k,v){
            html += '<tr class=\"'+(k%2 == 0 ? 'subgridRowAlt' : '')+'\">';
            $.each(v, function(k1, obj){
                html += '<td class="membMergeTable__cell '+obj.name+'">'+obj.value+'</td>';
            });
            html += '</tr>';
        });
        html += '</table>';

        return html;
    }

    return value;
};

const getTinyMceDefaultSettings = (plugins) => {
    const tinyMceDefaultSettings = {
        script_url: '/js/tiny_mce/tiny_mce.js',
        content_css: 'css/tinymce.css',
        language: "ru",
        relative_urls: false,
        remove_script_host: false,
// default mce setting        theme: "advanced",
        theme_advanced_resizing: true,
// default mce setting     theme_advanced_toolbar_location: "top",
// default mce setting     theme_advanced_toolbar_align: "left",
// default mce setting     theme_advanced_statusbar_location: "bottom",
    };

    switch (plugins) {
        case 'multiple':
            Object.assign(tinyMceDefaultSettings, {
                plugins: "autolink,lists,pagebreak,style,layer,table,save,advhr,advimage,advlink,emotions,iespell,inlinepopups,insertdatetime,preview,media,searchreplace,print,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,advlist,images",
                theme_advanced_buttons1: "bold,italic,underline,strikethrough,|,justifyleft,justifycenter,justifyright,justifyfull,styleselect,formatselect,fontselect,fontsizeselect",
                theme_advanced_buttons2: "cut,copy,paste,pastetext,pasteword,|,search,replace,|,bullist,numlist,|,outdent,indent,blockquote,|,undo,redo,|,link,unlink,anchor,image,cleanup,help,|,insertdate,inserttime,|,forecolor,backcolor",
                theme_advanced_buttons3: "tablecontrols,|,hr,removeformat,visualaid,|,sub,sup,|,charmap,emotions,iespell,media,advhr,|,print,|,ltr,rtl,|,fullscreen",
                theme_advanced_buttons4: "insertlayer,moveforward,movebackward,absolute,|,styleprops,|,cite,abbr,acronym,del,ins,attribs,|,visualchars,nonbreaking,pagebreak,|,images,code,preview",
            });
            break;
        case 'plugin_paste':
            Object.assign(tinyMceDefaultSettings, {
                plugins: 'paste',
                paste_block_drop: true,
                paste_preprocess: function(pl, o) {
                    o.content = strip_tags_custom(o.content);
                },
                theme_advanced_buttons1: 'bold,italic,underline,bullist,numlist,code',
                theme_advanced_resizing_use_cookie: false,
            });
            break;
    }

    return tinyMceDefaultSettings;
};

const confirmEditModGridFormChanges = (xhtml, submitFunc = null, cancelFunc = null) => {
    return $('<div id="confirmEditModGridFormChangesForm"></div>')
        .html(xhtml)
        .dialog({
            autoOpen: true,
            title: 'Подтверждение',
            modal: true,
            position: ['middle', 150],
            width: 380,
            resizable: false,
            zIndex: 3001,
            closeOnEscape: false,
            close: function (ev, ui) {
                $(this).dialog('destroy').remove();
                $('#FormError').hide();
            },
            open: function (ev, ui) {
                $('.ui-dialog-buttonset :button').blur();
                $(this).parent().find('a.ui-dialog-titlebar-close').remove();
            },
            buttons: [
                {
                    text: "Отмена",
                    class: "fm-button f-left",
                    style: "color: #bdbdbd;",
                    click: function () {
                        if (typeof cancelFunc == 'function') {
                            cancelFunc();
                        }
                        $(this).dialog("close");
                    }
                },
                {
                    text: "Подтвердить",
                    class: "submit fm-button f-right",
                    click: function () {
                        if (typeof submitFunc == 'function') {
                            submitFunc();
                        }
                        $(this).dialog("close");
                        $('#sData').click();
                    }
                }
            ]
        });
};

/**
 * @param number - это число для которого нужно выполнить склонение окончания у существительного
 * @param txt - массив строк с выриантами склонений: ['вариант1', 'вариант2', 'вариант3'].
 * В вариант1 попадают слова с окончаниями для:
 *  1, 21, 31, 41, 51, 61, 71, 81, 91, 101, 121, 131, 141 и т.д.
 * В вариант2:
 *  2, 3, 4, 22, 23, 24, 32, 33, 34, 42, 43, 44 ... 102, 103, 104, 122, 123, 124, 132 и т.д
 * В вариант3:
 *  5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 26, 27, 28, 29, 30, 35 и т.д.
 * @param returnWithNumber - число вместе со строкой
 * @param cases
 * @returns {string}
 */
const declensionOfNumbers = (number, txt, returnWithNumber = true, cases = [2, 0, 1, 1, 1, 2]) => {
    const calcDeclension = txt[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]],
        numberOrEmpty = returnWithNumber ? number + ' ' : '';
    return numberOrEmpty + calcDeclension;
};

const convertHTMLEntity = (text) => {
    const span = document.createElement('span');

    return text
        .replace(/&[#A-Za-z0-9]+;/gi, (entity)=> {
            span.innerHTML = entity;
            return span.innerText;
        });
}

function prjrBeforeShowDelForm() {
    (async () => {
        const prjr_id = $('#grid').jqGrid('getGridParam', 'selrow');
        let prjrPopup = '';
        $('#dData').off('click').on('click', async () => {
            try {
                showAjaxLoading();
                const tr = await $.ajax({
                    type: 'POST',
                    url: 'php/tbl.PROJECTS.REGIONAL.php',
                    dataType: 'json',
                    data: {
                        'qryType': 'getCntObjectsByProject',
                        'prjr_id': prjr_id
                    }
                });
                hideAjaxLoading();
                checkSession(tr);
                if (tr.error) {
                    $.create_popup_dialog(
                        `<span class="error-msg">${tr.error}</span>`, 'Ошибка', false, false,
                        popupDialogId => $(popupDialogId.replace('popup_dialog', '#popup_dialog_form')).dialog({width: 280})
                    );
                    return false;
                }
                const cnt = parseInt(tr.cnt);
                if (cnt > 0) {
                    $.create_popup_dialog(
                        `У данного проекта ${declensionOfNumbers(cnt, ['объект', 'объекта', 'объектов'])}. <br/>Вы действительно хотите удалить проект?`,
                        'Предупреждение',
                        false,
                        [{
                            text: 'Удалить',
                            func: async () => await submitDeleteRegionalProject(prjr_id, prjrPopup)
                        }],
                        (popup_id) => {
                            prjrPopup = popup_id.replace('popup_dialog', '#popup_dialog_form');
                            $(prjrPopup).dialog({width: 280});
                        }
                    );
                } else if (cnt === 0) {
                    await submitDeleteRegionalProject(prjr_id, prjrPopup);
                } else {
                    $.create_popup_dialog(
                        `<span class="error-msg">Произошла ошибка подсчета количества объектов у проекта</span>`, 'Ошибка', false, false,
                        popupDialogId => $(popupDialogId.replace('popup_dialog', '#popup_dialog_form')).dialog({width: 280})
                    );
                    return false;
                }
            } catch (err) {
                hideAjaxLoading();
                $.create_popup_dialog(`<span class="error-msg">${err.responseText || err}</span>`, 'Ошибка');
                return false;
            }
        });
    })();
}

const submitDeleteRegionalProject = async (prjr_id, prjrPopup) => {
    try {
        showAjaxLoading();
        const tr = await $.ajax({
            type: 'POST',
            url: 'php/tbl.PROJECTS.REGIONAL.php',
            dataType: 'json',
            data: {
                'oper': 'del',
                'prjr_id': prjr_id
            }
        });
        hideAjaxLoading();
        checkSession(tr);
        $(prjrPopup).dialog('close');
        $.jgrid.hideModal("#delmodgrid");
        $('#grid').trigger('reloadGrid');
    } catch (err) {
        hideAjaxLoading();
        $.create_popup_dialog(`<span class="error-msg">${err.responseText || err}</span>`, 'Ошибка');
        return false;
    }
};

const passwordValidationCheck = ({login, password = ''}) => {
    try {
        const passwordValidator = new Erdb.Service.PasswordValidator();
        passwordValidator.runMemberPasswordValidation({ email: login, password });
        const result = passwordValidator.isMemberPasswordValid;
        if (result) {
            return { result, message: 'Надёжный пароль' };
        }
        else {
            return { result, message: passwordValidator.passwordValidationErrorMessage };
        }
    }
    catch(err) {
        console.log(err);
        $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
    }
};

function beforeShowFormCardfileDel(formId) {
    (async () => {
        const deleteForm = $(formId);
        const selectedRowId = $('#grid tr.ui-state-hover').prop('id') || $('#grid').jqGrid('getGridParam', 'selrow');
        const selectedRowIdParts = selectedRowId.split(/_/);
        const userId = selectedRowIdParts[0];
        const subdivisionId = selectedRowIdParts[1];
        const notEditableSubdivisions = [106,107,108,109,110,189];
        const allSubdivisions = [];
        const chosenSubdivisions = [];

        deleteForm.html('');
        deleteForm.parent().find('#dData').hide();

        try {
            showAjaxLoading();
            const tr = await $.ajax({
                type: 'POST',
                url: 'php/getData.php',
                dataType: 'json',
                data:{
                    qryType: 'getPostNames',
                    emplId: userId
                }
            });

            hideAjaxLoading();
            checkSession(tr);

            let xhtml = `
                <div class="cardfileDelSubdivisionsList">
                    <p class="cardfileDelSubdivisionsList__head">Выберите из каких подразделений удалить:</p>
                    <div class="cardfileDelSubdivisionsList__checkboxes">
            `;
            let reminderText = '';
            tr.data.empl_sd.forEach((subdivisionData) => {
                allSubdivisions.push(subdivisionData.sd_id);
                let labelClass = '', isCheckboxDisabled = '', reminderSign = '';
                if (notEditableSubdivisions.includes(Number(subdivisionData.sd_id))) {
                    labelClass = 'class="grey"';
                    isCheckboxDisabled = 'disabled';
                    reminderSign = '<span class="color-red">*</span>';
                    reminderText = '<span class="color-red">* Для удаления из этого подразделения отредактируйте в <a href="#members_list">гриде персоналий</a></span>';
                }
                xhtml += `
                    <label ${labelClass}>
                        <input 
                            class="cardfileDelSubdivisionsList__subdivisionCheckbox" 
                            sd_id="${subdivisionData.sd_id}" 
                            type="checkbox" 
                            ${isCheckboxDisabled}
                        >
                        <span>${subdivisionData.sd_name}</span>${reminderSign}
                    </label>
                `;
            });
            xhtml += `</div></div><hr>${reminderText}`;

            if (notEditableSubdivisions.includes(Number(subdivisionId))) {
                deleteForm.html(`Невозможно удалить выбранную запись из картотеки. Для удаления отредактируйте в <a href="#members_list">гриде персоналий</a>`);
            }
            else {
                deleteForm.html(xhtml);
            }

            let isAllSubdivisionsAreChosen = true;
            $('.cardfileDelSubdivisionsList__checkboxes').change(function (event) {
                isAllSubdivisionsAreChosen = true;
                chosenSubdivisions.length = 0;
                deleteForm.parent().find('#dData').hide();
                const eventTarget = $(event.target);
                if (eventTarget.hasClass('cardfileDelSubdivisionsList__subdivisionCheckbox')) {
                    $('.cardfileDelSubdivisionsList__subdivisionCheckbox').each(function () {
                        const _this = $(this);
                        if (_this.prop('checked')) {
                            chosenSubdivisions.push(_this.attr('sd_id'));
                            deleteForm.parent().find('#dData').show();
                        }
                        else {
                            isAllSubdivisionsAreChosen = false;
                        }
                    });
                }
            });

            $('#dData').off('click').on('click', async () => {
                try {
                    showAjaxLoading();

                    let isOperatorDisablingConfirmationReceived = false;
                    if ($('#confirmOperatorDisablingDialog').length > 0) {
                        $('#confirmOperatorDisablingDialog').parent().remove();
                        $('#confirmOperatorDisablingDialog').remove();
                        isOperatorDisablingConfirmationReceived = true;
                    }

                    const remainingSubdivisions = allSubdivisions.filter((subdivisionId) => !chosenSubdivisions.includes(subdivisionId));
                    const tr = await $.ajax({
                        type: 'POST',
                        url: 'php/tbl.CARDFILE.php',
                        dataType: 'json',
                        data: {
                            'oper': 'del',
                            'rowId': selectedRowId,
                            'subdivisionsIdForDelete': chosenSubdivisions,
                            'isAllSubdivisionsAreChosen': isAllSubdivisionsAreChosen,
                            'remainingSubdivisions': remainingSubdivisions,
                            'isOperatorDisablingConfirmationReceived': isOperatorDisablingConfirmationReceived
                        }
                    });
                    hideAjaxLoading();
                    checkSession(tr);

                    if (tr?.isOperatorDisablingConfirmationRequired) {
                        createConfirmOperatorDisablingDialog({
                            isVpshUsers: tr.isVpshUsers,
                            isUpUsers: tr.isUpUsers,
                            isUpAccessRights: tr.isUpAccessRights,
                            isNewsletterUsers: tr.isNewsletterUsers,
                            operType: 'del'
                        });
                        return false;
                    }

                    $.jgrid.hideModal("#delmodgrid");
                    $('#grid').trigger('reloadGrid');
                } catch (err) {
                    hideAjaxLoading();
                    $.create_popup_dialog(`<span class="error-msg">${err.responseText || err}</span>`, 'Ошибка');
                    return false;
                }
            });
        }
        catch (err) {
            hideAjaxLoading();
            $.create_popup_dialog(`<span class="error-msg">${err.responseText || err}</span>`, 'Ошибка');
            return false;
        }
    })();
}

function showPasswordValidationTooltip(targetElementSelector, passwordValidationTooltipCssStyle, login) {
    try {
        const targetElement = $(targetElementSelector);

        const passwordValidator = new Erdb.Service.PasswordValidator('simultaneous_check');
        passwordValidator.runMemberPasswordValidation({email: login, password: targetElement.val()});

        if (!$('.passwordValidationTooltip').length) {
            let tooltipElementContent = `<div class="passwordValidationTooltip" style="${passwordValidationTooltipCssStyle}"><p>Требования к сложности пароля:</p>`;
            if (passwordValidator.passwordValidationAllErrorMessages[0]) {
                tooltipElementContent += `<p class="passwordValidationTooltip__rule color-red" data-validation_method_id="0">${passwordValidator.passwordValidationAllErrorMessages[0]}</p>`;
            }
            else {
                for (const [validationMethodId, errorMessage] of Object.entries(passwordValidator.allPossibleErrorMessages)) {
                    const ruleTextColor = passwordValidator.passwordValidationAllErrorMessages.hasOwnProperty(validationMethodId) ? 'color-red' : 'color-green';
                    tooltipElementContent += `<p class="passwordValidationTooltip__rule ${ruleTextColor}" data-validation_method_id="${validationMethodId}">${errorMessage}</p>`;
                }
            }
            tooltipElementContent += '</div>';

            targetElement.after(tooltipElementContent);
        }
        else {
            $('.passwordValidationTooltip__rule').each(function () {
                const _this = $(this);
                if (passwordValidator.passwordValidationAllErrorMessages[_this.data('validation_method_id')]) {
                    _this.addClass('color-red').removeClass('color-green');
                }
                else {
                    _this.addClass('color-green').removeClass('color-red');
                }
            });
        }
    }
    catch(err) {
        console.log(err);
        $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
    }
}

function createConfirmOperatorDisablingDialog({isVpshUsers, isUpUsers, isUpAccessRights, isNewsletterUsers, operType}) {
    let dialogTitle, operationConfirmButton, errorField;
    if (operType === 'del') {
        dialogTitle = 'Подтверждение удаления';
        operationConfirmButton = $('#dData');
        errorField = $('#DelError');
    }
    else if (operType === 'edit') {
        dialogTitle = 'Подтверждение редактирования';
        operationConfirmButton = $('#sData');
        errorField = $('#FormError');
    }

    const question = `
        Удаляемый оператор также будет удален из разделов:<br><br>
        <ul>
            ${isVpshUsers ? '<li>&bull; ИС Партии / ВПШ / Пользователи</li>' : ''}
            ${isUpUsers ? '<li>&bull; ИС Партии / ВВЕРХ / Операторы</li>' : ''}
            ${isUpAccessRights ? '<li>&bull; ИС Партии / ВВЕРХ / Права доступа</li>' : ''}
            ${isNewsletterUsers ? '<li>&bull; ИС Партии / NEWSLETTER / Пользователи</li>' : ''}
        </ul><br>
        <p class="color-red">При необходимости вам нужно будет добавить его в эти разделы заново.</p> 
        Продолжить?
    `;

    $('<div id="confirmOperatorDisablingDialog"></div>')
        .html(question)
        .dialog({
            title: dialogTitle,
            modal: true,
            zIndex : 3001,
            width: 500,
            close: function() {
                errorField.hide();
                $('#confirmOperatorDisablingDialog').parent().remove();
                $('#confirmOperatorDisablingDialog').remove();
            },
            buttons: [
                {
                    text: 'Да',
                    click: function() {
                        errorField.hide();
                        operationConfirmButton.click();
                    }
                },
                {
                    text: 'Нет',
                    click: function() {
                        $(this).dialog('close');
                    }
                }
            ]
        });
}

function afterSubmitForConfirmOperatorDisabling(response, postdata) {
    if (response.status == 200 && response.responseText) {
        try {
            var res = JSON.parse(response.responseText);
            if (res.isOperatorDisablingConfirmationRequired) {
                createConfirmOperatorDisablingDialog({
                    isVpshUsers: res.isVpshUsers,
                    isUpUsers: res.isUpUsers,
                    isUpAccessRights: res.isUpAccessRights,
                    isNewsletterUsers: res.isNewsletterUsers,
                    operType: postdata.oper
                });
                return [false, 'Подтверждение'];
            }
        }
        catch(e) { console.error(e); }
    }
    return [true];
}

function onclickSubmitForConfirmOperatorDisabling(params) {
    if ($('#confirmOperatorDisablingDialog').length > 0) {
        $('#confirmOperatorDisablingDialog').parent().remove();
        $('#confirmOperatorDisablingDialog').remove();
        return {isOperatorDisablingConfirmationReceived: true};
    }
}

function generateMemberPassword(count = 10) {
    const getRandomIntInclusive = (min, max) => {
        // Максимум и минимум включаются
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const sets = [
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        '!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}~',
        '0123456789',
        'abcdefghijklmnopqrstuvwxyz',
    ];
    let password = '';
    let error = '';

    sets.sort(() => Math.random() - 0.5);

    for (let i = 0; i < count; i++) {
        const currentSetIndex = i % sets.length
        const currentSet = sets[currentSetIndex]
        const value = getRandomIntInclusive(0, currentSet.length - 1)
        const currentValue = currentSet[value];
        if (typeof currentValue !== 'string') {
            error = 'произошла ошибка при генерации пароля'
            break
        } else {
            password += currentValue
        }
    }

    return {
        error,
        password
    };
}
